import type { EmailValue } from 'components/EmailTo'
import type { TagMatch } from 'components/TagMatchToggle'
import {
  API_ACH_RUN_DEBIT_NOTICES,
  API_ACH_RUN_DEBIT_NOTICES_SEND,
  API_CONSTRUCTION_LEDGER,
  API_CREDIT_REPORTING_CONFIG,
  API_CREDIT_REPORTING_CYCLE,
  API_CREDIT_REPORTING_ENROLL,
  API_CREDIT_REPORTING_LOAN,
  API_CREDIT_REPORTING_PREVIEW,
  API_CREDIT_REPORTING_RUN_DOWNLOAD,
  API_CREDIT_REPORTING_RUN_REPORT,
  API_CREDIT_REPORTING_RUN_SUBMIT,
  API_CREDIT_REPORTING_RUN_VOID,
  API_CREDIT_REPORTING_RUNS,
  API_CREDIT_REPORTING_SNAPSHOT,
  API_CREDIT_REPORTING_VALIDATE,
  API_DEPOSIT_NOTICE_CONFIG,
  API_DRAW_ADVISORY,
  API_GLOBAL_DRAW,
  API_GLOBAL_DRAW_PARTICIPANTS,
  API_GLOBAL_DRAW_PAYEES,
  API_LOAN_ALL_SERVICING_DOCUMENTS,
  API_LOAN_APPLY_EXTENSION_MATURITY_DATE,
  API_LOAN_ARM_PORTFOLIO,
  API_LOAN_ARM_PREVIEW,
  API_LOAN_ARM_RUN,
  API_LOAN_ARM_RUN_ALL,
  API_LOAN_ARM_RUNS,
  API_LOAN_CHARGE,
  API_LOAN_CHARGE_CATEGORY,
  API_LOAN_CHARGE_CATEGORY_UPDATE,
  API_LOAN_CHARGE_CATEGORY_USED,
  API_LOAN_CHARGE_LENDERS,
  API_LOAN_CHARGE_SPLIT_PAYEES,
  API_LOAN_CHARGE_SUMMARY,
  API_LOAN_CHARGE_UPDATE,
  API_LOAN_CHARGE_WAIVE,
  API_LOAN_COLLATERAL,
  API_LOAN_COLLATERAL_ITEM,
  API_LOAN_COMBINED_PAYOFF_CANDIDATES,
  API_LOAN_COMBINED_PAYOFF_LINE_ITEMS,
  API_LOAN_CONTACT,
  API_LOAN_CONTACT_UPDATE,
  API_LOAN_CREATE_SERVICE_EXTENSION,
  API_LOAN_DEBIT_REQUEST,
  API_LOAN_DEBIT_REQUEST_CANCEL,
  API_LOAN_DEBIT_REQUEST_DRAFT,
  API_LOAN_DEBIT_REQUEST_PREVIEW,
  API_LOAN_DEBIT_REQUEST_QUEUE,
  API_LOAN_DEBIT_REQUEST_RE_REQUEST,
  API_LOAN_DEBIT_REQUEST_SETTLE,
  API_LOAN_DEBIT_REQUESTS,
  API_LOAN_DELETE_SERVICE_EXTENSION,
  API_LOAN_DOWNLOAD_LOAN_INTAKE_DOC,
  API_LOAN_DOWNLOAD_SERVICING_DOC2,
  API_LOAN_DOWNLOAD_TAX_FORMS,
  API_LOAN_EMAIL_EXTENSION,
  API_LOAN_ESCROW_ANALYSIS,
  API_LOAN_ESCROW_ANALYSIS_APPLY,
  API_LOAN_ESCROW_ANALYSIS_DEFAULTS,
  API_LOAN_ESCROW_ANALYSIS_PREVIEW,
  API_LOAN_ESCROW_ANALYSIS_STATEMENT,
  API_LOAN_ESCROW_ANALYSIS_STATEMENTS,
  API_LOAN_EXTENSION_DOCUMENT_DEFAULTS,
  API_LOAN_EXTENSION_DOCUMENT_TEMPLATES,
  API_LOAN_EXTENSION_SIGNATURE_RECIPIENTS,
  API_LOAN_EXTENSION_SIGNING_PACKAGE,
  API_LOAN_FCI_ATTACHMENTS,
  API_LOAN_FCI_BORROWER_PAYMENTS,
  API_LOAN_FCI_CHARGES,
  API_LOAN_FCI_DOWNLOAD_ATTACHMENTS,
  API_LOAN_FCI_FUNDING_HISTORY,
  API_LOAN_FCI_LOAN_DETAIL,
  API_LOAN_FCI_LOANPORTFOLIO,
  API_LOAN_FCI_ONE_TIME_PAYMENT_LINK,
  API_LOAN_GENERATE_COMBINED_PAYOFF,
  API_LOAN_GENERATE_EXTENSION_DOCUMENT,
  API_LOAN_GENERATE_PAYOFF,
  API_LOAN_GENERATE_REINSTATEMENT,
  API_LOAN_GET_ACH,
  API_LOAN_GET_ACH_LOG,
  API_LOAN_GET_LOAN_INTAKE_DOCUMENTS_DATA,
  API_LOAN_GET_ONE_SERVICE_EXTENSION,
  API_LOAN_GET_ORDER_OUTS,
  API_LOAN_GET_ORDER_OUTS_CHECK_PLACEHOLDER,
  API_LOAN_GET_ORDER_OUTS_DOWNLOAD,
  API_LOAN_GET_SERVICE_EXTENSION,
  API_LOAN_GET_SERVICING_BORROWING_BASE,
  API_LOAN_GET_SERVICING_BORROWING_BASE_LOG,
  API_LOAN_GET_SERVICING_DEFAULT_TRACKING,
  API_LOAN_GET_SERVICING_DEFAULT_TRACKING_LOG,
  API_LOAN_GET_SERVICING_DOCUMENTS_DATA,
  API_LOAN_GET_SERVICING_HOLD,
  API_LOAN_GET_SERVICING_NOTES,
  API_LOAN_GET_SERVICING_NOTES_LOG,
  API_LOAN_INVESTOR,
  API_LOAN_INVESTOR_UPDATE,
  API_LOAN_INVOICE,
  API_LOAN_INVOICE_AI_EXTRACT,
  API_LOAN_INVOICE_DOWNLOAD,
  API_LOAN_INVOICE_LOG,
  API_LOAN_INVOICE_UPDATE,
  API_LOAN_MASS_SEND_SERVICING_DOCUMENTS,
  API_LOAN_NSF_CONFIG,
  API_LOAN_NSF_GENERATE_NOTICE,
  API_LOAN_NSF_NOTICE,
  API_LOAN_NSF_SEND_NOTICE,
  API_LOAN_PAYABLE_BY_ID,
  API_LOAN_PAYABLE_PAYEES,
  API_LOAN_PAYABLE_SUGGESTIONS,
  API_LOAN_PAYABLES,
  API_LOAN_PAYMENT,
  API_LOAN_PAYMENT_BY_ID,
  API_LOAN_PAYMENT_DISTRIBUTION_PREVIEW,
  API_LOAN_PAYMENT_DOWNLOAD,
  API_LOAN_PAYMENT_FILL,
  API_LOAN_PAYMENT_LATE_CHARGE_CALCULATION,
  API_LOAN_PAYMENT_LOG,
  API_LOAN_PAYMENT_PAYOFF_CHARGES,
  API_LOAN_PAYMENT_PHONE,
  API_LOAN_PAYMENT_PHONE_AVAILABILITY,
  API_LOAN_PAYMENT_PHONE_DEFAULTS,
  API_LOAN_PAYMENT_PHONE_QUOTE,
  API_LOAN_PAYOFF_LINE_ITEMS,
  API_LOAN_PAYOFF_STATEMENT,
  API_LOAN_PAYOFF_STATEMENT_APPROVE,
  API_LOAN_PAYOFF_STATEMENT_PDF,
  API_LOAN_PAYOFF_STATEMENT_RECORD_RELEASE,
  API_LOAN_PAYOFF_STATEMENTS,
  API_LOAN_PENALTY,
  API_LOAN_PIPELINE_SERVICING_PARTIES,
  API_LOAN_REINSTATEMENT_LINE_ITEMS,
  API_LOAN_SEND_EXTENSION_DOCUMENT,
  API_LOAN_SEND_EXTENSION_FOR_SIGNATURE,
  API_LOAN_SEND_LOAN_INTAKE_DOC_EMAIL,
  API_LOAN_SEND_ORDER_OUT_EMAIL,
  API_LOAN_SEND_SERVICING_DOC_EMAIL,
  API_LOAN_SERVICING_DEFAULTS,
  API_LOAN_SERVICING_DEFAULTS_BULK,
  API_LOAN_SERVICING_INSURANCE_AI_EXTRACT,
  API_LOAN_SERVICING_PARTICIPATION,
  API_LOAN_SERVICING_PARTICIPATION_DISTRIBUTIONS,
  API_LOAN_SERVICING_PARTICIPATION_FUNDING,
  API_LOAN_SERVICING_PARTICIPATION_FUNDING_BY_ID,
  API_LOAN_SERVICING_PARTICIPATION_FUNDING_DEBIT,
  API_LOAN_SERVICING_PARTICIPATION_FUNDING_DEBIT_PREVIEW,
  API_LOAN_SERVICING_PARTICIPATION_FUNDING_DEBIT_REVERSE,
  API_LOAN_SERVICING_PARTICIPATION_GENERATE,
  API_LOAN_SERVICING_PARTICIPATION_RESET,
  API_LOAN_SERVICING_PARTICIPATION_UPB_RESTORE,
  API_LOAN_SERVICING_PARTICIPATION_UPDATE,
  API_LOAN_SERVICING_REPORT,
  API_LOAN_SIGN_EXTENSION_AGREEMENT,
  API_LOAN_TERM_CHANGE,
  API_LOAN_TERM_CHANGE_NOTICE,
  API_LOAN_TERM_CHANGE_NOTICE_EMAIL,
  API_LOAN_TERM_CHANGES,
  API_LOAN_TRID_IMPORTANT_DATES,
  API_LOAN_TRUST_LEDGER_DRAW_ISSUED_TASK,
  API_LOAN_TRUST_LEDGER_INTEREST,
  API_LOAN_TRUST_LEDGER_INTEREST_CREATE,
  API_LOAN_TRUST_LEDGER_INTEREST_DELETE,
  API_LOAN_TRUST_LEDGER_INTEREST_TRANSFER,
  API_LOAN_TRUST_LEDGER_INTEREST_UPDATE,
  API_LOAN_TRUST_LEDGER_ORDER_HISTORY,
  API_LOAN_UPDATE_LOAN_INTAKE_DOC_DATA,
  API_LOAN_UPDATE_SERVICE_EXTENSION,
  API_LOAN_VOUCHER_BY_ID,
  API_LOAN_VOUCHER_PROJECTION,
  API_LOAN_VOUCHERS,
  API_NOTE,
  API_NOTE_BY_ID,
  API_NOTE_PIN_BY_ID,
  API_NOTE_PINNED,
  API_NOTE_READ_BY_ID,
  API_PAYMENT_CHECK_DEPOSIT_NOTICES,
  API_PAYMENT_CHECK_DEPOSIT_NOTICES_SEND,
  API_PAYMENT_CHECK_HOLD,
  API_PAYMENT_CHECK_PAY,
  API_PAYMENT_CHECK_PROVIDER,
  API_PAYMENT_CHECK_QUEUE,
  API_PAYMENT_CHECK_QUEUE_EXCEL,
  API_PAYMENT_CHECK_REMITTANCE,
  API_PAYMENT_CHECK_REPRINT,
  API_PAYMENT_CHECK_RETURNED,
  API_PAYMENT_CHECK_RETURNED_UNDO,
  API_PAYMENT_CHECK_RUN_DATE,
  API_PAYMENT_CHECK_RUN_DELETE,
  API_PAYMENT_CHECK_RUN_DOWNLOAD,
  API_PAYMENT_CHECK_RUN_EXCEL,
  API_PAYMENT_CHECK_RUN_PRINT,
  API_PAYMENT_CHECK_RUN_REPORT,
  API_PAYMENT_CHECK_RUN_REPORT_DATA,
  API_PAYMENT_CHECK_RUN_REVERSE,
  API_PAYMENT_CHECK_RUN_SUBMIT_PROVIDER,
  API_PAYMENT_CHECK_RUNS,
  API_PAYMENT_VOUCHER_APPROVE,
  API_PAYMENT_VOUCHER_BY_ID,
  API_PAYMENT_VOUCHER_CONSTRUCTION,
  API_PAYMENT_VOUCHER_CONSTRUCTION_SUGGESTIONS,
  API_PAYMENT_VOUCHER_REJECT,
  API_PAYMENT_VOUCHER_REPORT,
  API_PAYMENT_VOUCHERS,
  API_RATE_INDEX,
  API_RATE_INDEX_SYNC,
  API_RATE_INDEX_UPDATE,
  API_RATE_INDEX_VALUE_DELETE,
  API_RATE_INDEX_VALUES,
  API_SERVICING_ACH_CONFIG,
  API_SERVICING_ACH_LIST,
  API_SERVICING_ACH_LIST_EXCEL,
  API_SERVICING_ACH_NACHA,
  API_SERVICING_ACH_PROCESS,
  API_SERVICING_ACH_PROCESS_STATUS,
  API_SERVICING_ACH_PROVIDER,
  API_SERVICING_ACH_RETURNS,
  API_SERVICING_ACH_RETURNS_APPLY,
  API_SERVICING_ACH_RETURNS_IGNORE,
  API_SERVICING_ACH_RETURNS_SWEEP,
  API_SERVICING_ACH_RUN_DELETE,
  API_SERVICING_ACH_RUN_DOWNLOAD,
  API_SERVICING_ACH_RUN_EXCEL,
  API_SERVICING_ACH_RUN_REPORT,
  API_SERVICING_ACH_RUN_REPORT_DATA,
  API_SERVICING_ACH_RUN_REVERSE,
  API_SERVICING_ACH_RUN_SUBMIT_PROVIDER,
  API_SERVICING_ACH_RUNS,
  API_SERVICING_ACH_SCHEDULE,
  API_SERVICING_ACH_SCHEDULE_RUN,
  API_SERVICING_PAYMENT_DEFAULTS,
  API_SERVICING_PAYMENT_DEFAULTS_LOAN,
  API_SERVICING_PAYMENT_DEFAULTS_SCAN,
  API_SERVICING_STATEMENT_BATCH,
  API_SERVICING_STATEMENT_BATCH_DELETE,
  API_SERVICING_STATEMENT_BATCH_DOWNLOAD,
  API_SERVICING_STATEMENT_BATCH_EMAIL,
  API_SERVICING_STATEMENT_BATCHES,
  API_SERVICING_STATEMENT_DELETE,
  API_SERVICING_STATEMENT_DOWNLOAD,
  API_SERVICING_STATEMENT_EMAIL,
  API_SERVICING_STATEMENT_GENERATE_ONE,
  API_SERVICING_STATEMENT_SCHEDULE,
  API_SERVICING_STATEMENT_SCHEDULE_BY_ID,
  API_SERVICING_STATEMENT_SCHEDULE_BY_ID_RUN,
  API_SERVICING_STATEMENT_SCHEDULE_RUN,
  API_SERVICING_STATEMENT_SCHEDULES,
  API_SERVICING_STATEMENTS,
  API_SERVICING_STATEMENTS_GENERATE,
  API_SERVICING_STATEMENTS_GENERATE_CANCEL,
  API_SERVICING_STATEMENTS_GENERATE_STATUS,
  API_SERVICING_STATEMENTS_LOAN,
  API_SERVICING_TAX_FORM,
  API_SERVICING_TAX_FORM_BATCH,
  API_SERVICING_TAX_FORM_BATCH_EMAIL,
  API_SERVICING_TAX_FORM_BATCHES,
  API_SERVICING_TAX_FORM_CANDIDATES,
  API_SERVICING_TAX_FORM_DOWNLOAD,
  API_SERVICING_TAX_FORM_EMAIL,
  API_SERVICING_TAX_FORMS_GENERATE,
  API_SERVICING_TAX_FORMS_GENERATE_CANCEL,
  API_SERVICING_TAX_FORMS_GENERATE_STATUS,
  API_SERVICING_TAX_FORMS_LOAN,
  API_SERVICING_WORKFLOW_CONFIG,
  API_SERVICING_WORKFLOW_RUN,
  API_TRUST_LEDGER,
  API_TRUST_LEDGER_ADDITIONAL,
  API_TRUST_LEDGER_ADDITIONAL_INFO,
  API_TRUST_LEDGER_ALL,
  API_TRUST_LEDGER_CREDIT_LINE,
  API_TRUST_LEDGER_DRAW_TYPE,
  API_TRUST_LEDGER_NOTIFICATION,
  API_TRUST_LEDGER_STATUS_CHANGE_DRAW_AGREEMENT,
  API_TRUST_LEDGER_VALIDATE_SIGN_SIGNATURE,
  appApiUrl,
  BaseFile,
} from 'config'
import { NotePageType } from 'pages/Loan/Servicing/Notes/types'
import { store } from 'reducers'
import Api from 'services/api'
import { confirm, getLoanDisplayNo } from 'utils'

import { downloadFile } from '../documents'

export const getServicingBorrowingBaseLog = (key: string) => {
  return Api.get(API_LOAN_GET_SERVICING_BORROWING_BASE_LOG, {}, { key })
}

export const getServicingBorrowingBase = () => {
  return Api.get(API_LOAN_GET_SERVICING_BORROWING_BASE)
}

export const postServicingBorrowingBase = (data: Record<string, any>) => {
  return Api.post(API_LOAN_GET_SERVICING_BORROWING_BASE, data)
}

export const getServicingDefaultTrackingLog = (key: string) => {
  return Api.get(API_LOAN_GET_SERVICING_DEFAULT_TRACKING_LOG, {}, { key })
}

export const getServicingDefaultTracking = () => {
  return Api.get(API_LOAN_GET_SERVICING_DEFAULT_TRACKING)
}

export const postServicingDefaultTracking = (data: Record<string, any>) => {
  return Api.post(API_LOAN_GET_SERVICING_DEFAULT_TRACKING, data)
}

export const getServicingNotes = () => {
  return Api.get(API_LOAN_GET_SERVICING_NOTES)
}

/** Just the loan's servicing Hold flag, for screens that need it before the user starts typing. */
export const getServicingHold = () => {
  return Api.get(API_LOAN_GET_SERVICING_HOLD)
}

export const postServicingNotes = (data: object) => {
  return Api.post(API_LOAN_GET_SERVICING_NOTES, data)
}

export type InsuranceAiExtractData = {
  insurancePolicyNo: string | null
  insurancePolicyType: string | null
  insurancePolicyCoverageAmount: number | null
  insuranceStartDate: string | null
  insuranceP1Exp: string | null
  insCancelDate: string | null
  insCancelReason: string | null
  insInfoReq1Date: string | null
  insurancePremium: number | null
  insuranceMonthlyPayment: number | null
  insuranceAmountCollected: number | null
  insuranceMonthCollected: number | null
  insuranceAgentName: string | null
  insuranceAgentAddress: string | null
  insuranceCompanyName: string | null
  insurancePhoneNumber: string | null
  insuranceEmail: string | null
  insuranceNotes: string | null
  sourceFile?: { fileKey: string; name: string }
}

export const extractInsuranceFromPdf = (files: Array<{ fileKey: string; name: string }>) => {
  return Api.post(API_LOAN_SERVICING_INSURANCE_AI_EXTRACT, { files }, {}, { timeout: 0 })
}

export const getServicingDocumentData = () => {
  return Api.get(API_LOAN_GET_SERVICING_DOCUMENTS_DATA)
}

export const getPipelineServicingParties = (data: {
  loanNumbers?: number[]
  filters?: Record<string, any>
  partyType?: string
  partyTypes?: string[]
}) => {
  return Api.post(API_LOAN_PIPELINE_SERVICING_PARTIES, data)
}

export const getAllServicingDocuments = () => {
  return Api.get(API_LOAN_ALL_SERVICING_DOCUMENTS)
}

export const massSendServicingDocuments = (data: {
  recipients: Array<{ loanNumber: number; email: string; role: 'to' | 'cc' | 'bcc' }>
  documents: Array<{ name: string; source: string }>
  emailData: Record<string, string>
  emails: EmailValue
}) => {
  return Api.post(API_LOAN_MASS_SEND_SERVICING_DOCUMENTS, data)
}

export const getLoanIntakeDocumentData = () => {
  return Api.get(API_LOAN_GET_LOAN_INTAKE_DOCUMENTS_DATA)
}

export const updateLoanIntakeDocumentData = (data: Record<string, any>) => {
  return Api.post(API_LOAN_UPDATE_LOAN_INTAKE_DOC_DATA, { data })
}

export const getTridImportantDates = () => {
  return Api.get(API_LOAN_TRID_IMPORTANT_DATES)
}

export const updateTridImportantDates = (data: Record<string, any>) => {
  return Api.post(API_LOAN_TRID_IMPORTANT_DATES, { data })
}

// Word is only offered for the Docgen-sourced templates; the TMO reports are PDF-only and the
// backend refuses `docx` for them rather than renaming a PDF.
export const downloadServicingDocs2 = async (doc: Record<string, any>, format: 'pdf' | 'docx' = 'pdf') => {
  const response: Blob = await Api.post(
    API_LOAN_DOWNLOAD_SERVICING_DOC2,
    { name: doc.name, source: doc.source, format },
    {},
    {
      responseType: 'blob',
    },
  )

  downloadFile(`${doc.name} - ${Api.getLoanNumber()}.${format}`, response)
}

export const downloadLoanIntakeDocs = async (name: string) => {
  const response: Blob = await Api.post(
    API_LOAN_DOWNLOAD_LOAN_INTAKE_DOC,
    { name },
    {},
    {
      responseType: 'blob',
    },
  )

  downloadFile(`${name} - ${Api.getLoanNumber()}.pdf`, response)
}

export const sendServicingDocumentOnEmail = (
  doc: Record<string, any>,
  emailData: Record<string, string>,
  data: Record<string, any>,
) => {
  return Api.post(API_LOAN_SEND_SERVICING_DOC_EMAIL, { name: doc.name, source: doc.source, emailData, data })
}

export const sendLoanIntakeDocumentEmail = (
  name: string,
  emailData: Record<string, string>,
  data: Record<string, any>,
) => {
  return Api.post(API_LOAN_SEND_LOAN_INTAKE_DOC_EMAIL, { name, emailData, data })
}

export const getServicingParticipation = () => {
  return Api.get(API_LOAN_SERVICING_PARTICIPATION)
}

export const createServicingParticipation = (data: Record<string, any>) => {
  return Api.post(API_LOAN_SERVICING_PARTICIPATION, data)
}

export const updateServicingParticipation = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_SERVICING_PARTICIPATION_UPDATE, data, { id })
}

export const deleteServicingParticipation = (id: number) => {
  return Api.delete(API_LOAN_SERVICING_PARTICIPATION_UPDATE, {}, { id })
}

export const getParticipationFunding = () => {
  return Api.get(API_LOAN_SERVICING_PARTICIPATION_FUNDING)
}

export const createParticipationFunding = (data: Record<string, any>) => {
  return Api.post(API_LOAN_SERVICING_PARTICIPATION_FUNDING, data)
}

export const deleteParticipationFunding = (id: number) => {
  return Api.delete(API_LOAN_SERVICING_PARTICIPATION_FUNDING_BY_ID, {}, { id })
}

// Review which participants a funding event would ACH-debit and who is blocked, without drafting.
export const getParticipationFundingDebitPreview = (id: number) => {
  return Api.get(API_LOAN_SERVICING_PARTICIPATION_FUNDING_DEBIT_PREVIEW, {}, { id })
}

// Draft the ACH debit batch pulling each participant's funded share from their bank account.
export const generateParticipationFundingDebit = (id: number, data: { effectiveDate?: string } = {}) => {
  return Api.post(API_LOAN_SERVICING_PARTICIPATION_FUNDING_DEBIT, data, { id })
}

// Reverse a funding debit: mark its ACH run reversed and re-enable drafting.
export const reverseParticipationFundingDebit = (id: number) => {
  return Api.post(API_LOAN_SERVICING_PARTICIPATION_FUNDING_DEBIT_REVERSE, {}, { id })
}

export const getParticipationDistributions = () => {
  return Api.get(API_LOAN_SERVICING_PARTICIPATION_DISTRIBUTIONS)
}

// Delete all funding for the loan, zero participant balances/history, and force the UPB to 0.
export const resetParticipationAndUpb = () => {
  return Api.post(API_LOAN_SERVICING_PARTICIPATION_RESET, {})
}

export const restoreUpbFromReset = () => {
  return Api.post(API_LOAN_SERVICING_PARTICIPATION_UPB_RESTORE, {})
}

export const generateServicingParticipation = async (id: number, loanNumber: number, byteproFileName: number) => {
  const response: Blob = await Api.post(
    API_LOAN_SERVICING_PARTICIPATION_GENERATE,
    {},
    { id },
    {
      responseType: 'blob',
    },
  )

  downloadFile(`Participation Agreement - ${getLoanDisplayNo({ byteproFileName, loanNumber })}.pdf`, response)
}

/**
 * Trust Ledger
 */

export const validateTrustLedgerSignature = (data: object) => {
  return Api.post(API_TRUST_LEDGER_VALIDATE_SIGN_SIGNATURE, data)
}

export const changeTrustLedgerAgreementStatus = (data: object) => {
  return Api.post(API_TRUST_LEDGER_STATUS_CHANGE_DRAW_AGREEMENT, data)
}

export const getTrustLedger = (loanNumber?: number) => {
  return Api.get(API_TRUST_LEDGER, {}, {}, loanNumber ? { loanNumber: String(loanNumber) } : {})
}

/**
 * What a revolving line of credit may still advance. Returns `revolving: false` with zeros for a
 * closed-end loan, which is every loan that has not been given a Facility Type, so callers can ask
 * unconditionally and show the construction figures when it says no.
 */
export const getTrustLedgerCreditLine = (asOf?: string) => {
  return Api.get(API_TRUST_LEDGER_CREDIT_LINE, asOf ? { asOf } : {})
}

export const getTrustLedgerAll = (params: Record<string, any> = {}) => {
  return Api.get(API_TRUST_LEDGER_ALL, params)
}

export const updateTrustLedgerDrawType = (drawType: string) => {
  return Api.put(API_TRUST_LEDGER_DRAW_TYPE, { drawType })
}

/** `loanNumber` scopes the lookup to another loan than the one in context (the invoice list). */
export const getTrustLedgerAdditionalInfo = (loanNumber?: number | string) => {
  return Api.get(API_TRUST_LEDGER_ADDITIONAL_INFO, {}, {}, loanNumber ? { loanNumber } : {})
}

export const addTrustLedger = (data: Record<string, any>) => {
  return Api.post(API_TRUST_LEDGER, data)
}

export const updateTrustLedger = (id: number, data: Record<string, any>) => {
  return Api.put(`${API_TRUST_LEDGER}/${id}`, data)
}

/**
 * The inspection-fee split on one Construction Reserve row: the shares it comes to, who they
 * resolve to today, and what became of the payouts already raised from it.
 */
export const getDrawFeeSplit = (id: number) => {
  return Api.get(`${API_TRUST_LEDGER}/${id}/feeSplit`)
}

/**
 * Store the shares on the row. Its own route rather than `updateTrustLedger`, which replaces the
 * row's whole jsonb with what is sent - so changing one key that way would mean round-tripping the
 * entire row through the browser and dropping anything this screen does not carry.
 */
export const saveDrawFeeSplit = (id: number, inspectionFeeSplits: any[]) => {
  return Api.put(`${API_TRUST_LEDGER}/${id}/feeSplit`, { inspectionFeeSplits })
}

/**
 * Raise that split in the check queue, or bring already-queued payouts back into line with the row.
 * Safe to send twice - it reconciles rather than appends.
 */
export const queueDrawFeeSplit = (id: number) => {
  return Api.post(`${API_TRUST_LEDGER}/${id}/feeSplit/queue`, {})
}

export const updateTrustLedgerAdditional = (data: Record<string, any>) => {
  return Api.put(API_TRUST_LEDGER_ADDITIONAL, data)
}

export const getTrustLedgerAdditionalHistory = (key: string) => {
  return Api.get(API_TRUST_LEDGER_ADDITIONAL, { key })
}

export const deleteTrustLedger = (id: number) => {
  return Api.delete(`${API_TRUST_LEDGER}/${id}`)
}

export const getConstructionLedger = () => {
  return Api.get(API_CONSTRUCTION_LEDGER)
}

export const submitTrustLedgerAfx = (id: number, data: Record<string, any>) => {
  return Api.post(`${API_TRUST_LEDGER}Afx/:id`, data, { id })
}

export const getTrustLedgerAfx = () => {
  return Api.get(`${API_TRUST_LEDGER}Afx`)
}

// Interest Trust Ledger
export const getTrustLedgerInterest = () => {
  return Api.get(API_LOAN_TRUST_LEDGER_INTEREST)
}
export const createTrustLedgerInterest = (data: Record<string, any>) => {
  return Api.post(API_LOAN_TRUST_LEDGER_INTEREST_CREATE, data)
}

/**
 * Move money off this loan's sub-ledger onto other loans' sub-ledgers. The backend writes each
 * destination as a matched pair, so no loan is left holding half a transfer.
 */
export const transferTrustLedgerInterest = (data: Record<string, any>) => {
  return Api.post(API_LOAN_TRUST_LEDGER_INTEREST_TRANSFER, data)
}

export const updateTrustLedgerInterest = (id: string, data: Record<string, any>) => {
  return Api.put(API_LOAN_TRUST_LEDGER_INTEREST_UPDATE, data, { id })
}

export const deleteTrustLedgerInterest = (id: string) => {
  return Api.delete(API_LOAN_TRUST_LEDGER_INTEREST_DELETE, {}, { id })
}

export const trustLedgerDrawIssuedAccountingTask = (data: any) => {
  return Api.post(API_LOAN_TRUST_LEDGER_DRAW_ISSUED_TASK, data)
}

export const getTrustLedgerOrderHistory = (id: number) => {
  return Api.get(API_LOAN_TRUST_LEDGER_ORDER_HISTORY, {}, { id })
}

export const sendTrustLedgerNotification = (
  ID: number,
  emails: EmailValue,
  emailType: string,
  files: Record<string, string>[],
  data: any,
) => {
  return Api.post(API_TRUST_LEDGER_NOTIFICATION, { ID, emails, emailType, files, data })
}

/**
 * Loan Service Extension
 */
export const updateLoanServiceExtension = (data: any, id: number) => {
  return Api.post(API_LOAN_UPDATE_SERVICE_EXTENSION, { data }, { id })
}

export const createLoanServiceExtension = (data: any) => {
  return Api.post(API_LOAN_CREATE_SERVICE_EXTENSION, data)
}

export const deleteLoanServiceExtension = (id: number) => {
  return Api.delete(API_LOAN_DELETE_SERVICE_EXTENSION, {}, { id })
}

export const getLoanServiceExtension = () => {
  return Api.get(API_LOAN_GET_SERVICE_EXTENSION)
}

export const getOneLoanServiceExtension = (id: string) => {
  return Api.get(API_LOAN_GET_ONE_SERVICE_EXTENSION, {}, { id })
}

export const sendEmailForLoanServiceExtension = (id: number) => {
  return Api.put(API_LOAN_UPDATE_SERVICE_EXTENSION, {}, { id })
}

export const getExtensionDocumentDefaults = () => {
  return Api.get(API_LOAN_EXTENSION_DOCUMENT_DEFAULTS)
}

export const getExtensionDocumentTemplates = () => {
  return Api.get(API_LOAN_EXTENSION_DOCUMENT_TEMPLATES)
}

export const downloadExtensionDocument = async (id: number, name: string) => {
  const response: Blob = await Api.post(
    API_LOAN_GENERATE_EXTENSION_DOCUMENT,
    { name },
    { id },
    {
      responseType: 'blob',
    },
  )

  downloadFile(`${name} - ${Api.getLoanNumber()}.pdf`, response)
}

export const sendExtensionDocument = (
  id: number,
  name: string,
  data: Record<string, any>,
  emailData: Record<string, string> = {},
) => {
  return Api.post(API_LOAN_SEND_EXTENSION_DOCUMENT, { name, data, emailData }, { id })
}

/**
 * Email about an extension to whoever the servicer picks, filed as an email note on the loan.
 * `attachAgreement` renders the extension's selected document and attaches it.
 */
export const emailExtension = (
  id: number,
  body: {
    emails: Record<string, string>
    subject: string
    content: string
    files?: any[]
    attachAgreement?: boolean
    name?: string
  },
) => {
  return Api.post(API_LOAN_EMAIL_EXTENSION, body, { id })
}

export const applyExtensionMaturityDate = (id: number) => {
  return Api.post(API_LOAN_APPLY_EXTENSION_MATURITY_DATE, {}, { id })
}

export const sendExtensionForSignature = (id: number, name?: string, emailData?: Record<string, string>) => {
  return Api.post(API_LOAN_SEND_EXTENSION_FOR_SIGNATURE, { name, emailData }, { id })
}

export const getExtensionSignatureRecipients = (id: number) => {
  return Api.get(API_LOAN_EXTENSION_SIGNATURE_RECIPIENTS, {}, { id })
}

export const getExtensionSigningPackage = (id: number | string) => {
  return Api.get(API_LOAN_EXTENSION_SIGNING_PACKAGE, {}, { id })
}

export const signExtensionAgreement = (id: number | string, name: string) => {
  return Api.post(API_LOAN_SIGN_EXTENSION_AGREEMENT, { name }, { id })
}

/**
 * Notes
 */
export const getNotes = (loanNumber: number, filters: Record<string, any>) => {
  return Api.get(API_NOTE, filters, { loanNumber })
}

export const addNewNote = (
  loanNumber: number,
  subject: string,
  content: string,
  files: BaseFile[] = [],
  notifiers: EmailValue = {},
  isEmail: boolean = false,
  replyData: Record<string, any> | null = null,
  notePageType: NotePageType = NotePageType.GLOBAL,
  links: any[] = [],
  mentions: string[] = [],
  mentionGroups: string[] = [],
) => {
  return Api.post(
    API_NOTE,
    { subject, content, files, notifiers, isEmail, replyData, notePageType, links, mentions, mentionGroups },
    { loanNumber },
  )
}

export const updateNote = (id: number, subject: string, content: string, files: BaseFile[], notifiers: EmailValue) => {
  return Api.put(API_NOTE_BY_ID, { subject, content, files, notifiers }, { id })
}

export const updateReadStatus = (id: number) => {
  return Api.put(API_NOTE_READ_BY_ID, {}, { id })
}

export const deleteNote = (id: number) => {
  return Api.delete(API_NOTE_BY_ID, {}, { id })
}

export const getPinnedNotes = (loanNumber: number) => {
  return Api.get(API_NOTE_PINNED, {}, { loanNumber })
}

export const updateNotePinned = (id: number, isPinned: boolean) => {
  return Api.put(API_NOTE_PIN_BY_ID, { isPinned }, { id })
}

/**
 * Invoices
 */
export const getLoanInvoices = (filters: Record<string, any>) => {
  return Api.get(API_LOAN_INVOICE, filters)
}

export const addNewLoanInvoice = (data: Record<string, any>) => {
  return Api.post(API_LOAN_INVOICE, data)
}

export const updateLoanInvoice = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_INVOICE_UPDATE, data, { id })
}

export const deleteLoanInvoice = (id: number) => {
  return Api.delete(API_LOAN_INVOICE_UPDATE, {}, { id })
}

export const downloadInvoices = async (filters: Record<string, any>) => {
  const res: Blob = await Api.get(
    API_LOAN_INVOICE_DOWNLOAD,
    filters,
    {},
    {
      responseType: 'blob',
    },
  )
  downloadFile(`Invoices.csv`, res)
}

export const getInvoiceLogs = (id: number, key: string) => {
  return Api.get(API_LOAN_INVOICE_LOG, {}, { id, key })
}

export const extractInvoiceFromPdf = (files: Array<{ fileKey: string; name: string }>) => {
  return Api.post(API_LOAN_INVOICE_AI_EXTRACT, { files }, {}, { timeout: 0 })
}

export const getLoanPaymentLogs = (id: number, key: string) => {
  return Api.get(API_LOAN_PAYMENT_LOG, {}, { id, key })
}

export const getLoanPayments = () => {
  return Api.get(API_LOAN_PAYMENT)
}

/**
 * Post a payment the server may want confirmed before it posts. It answers
 * `{ success: 0, confirm: '<warning>' }` when the payment is allowed but the operator has to be
 * told something first - keying money against a paid-off loan is the one that does this today - so
 * the warning is put up here and the post repeated with the answer. Doing it in one place keeps
 * every screen that takes a payment warning the same way; `cancelled` tells the caller the operator
 * said no, so it reports nothing and leaves the form as they keyed it.
 */
const postConfirmable = async (route: string, data: Record<string, any>, options: Record<string, any> = {}) => {
  const res: any = await Api.post(route, data, {}, options)
  if (!res?.confirm) return res
  if (!(await confirm(res.confirm, { titleYes: 'Post anyway' }))) return { success: 0, cancelled: true }
  return Api.post(route, { ...data, confirmClosedLoan: true }, {}, options)
}

export const createLoanPayment = (data: Record<string, any>) => {
  return postConfirmable(API_LOAN_PAYMENT, data)
}

// ---- NSF (fee + notice on a reversed payment) ----
export const getNsfConfig = (): Promise<{
  success: number
  fee: number
  template: string
  attach: boolean
  /** Default for emailing the notice to the borrower as soon as it's generated. */
  autoEmail: boolean
  /** Built-in notices (`builtin:<variant>`) first, then any Docgen servicing templates. */
  templates: Array<{ value: string; label: string; description?: string; builtin: boolean }>
}> => {
  return Api.get(API_LOAN_NSF_CONFIG)
}

export const saveNsfConfig = (data: { fee?: number; template?: string; attach?: boolean; autoEmail?: boolean }) => {
  return Api.post(API_LOAN_NSF_CONFIG, data)
}

export const sendNsfNotice = (reversalId: number) => {
  return Api.post(API_LOAN_NSF_SEND_NOTICE, {}, { reversalId })
}

/** Produce the notice for a returned payment that never got one (skipped, failed, or converted). */
export const generateNsfNotice = (
  reversalId: number,
): Promise<{ success: number; message: string; fileName?: string }> => {
  return Api.post(API_LOAN_NSF_GENERATE_NOTICE, {}, { reversalId })
}

/** The generated notice as a PDF blob, for viewing before it's sent. */
export const getNsfNotice = (reversalId: number): Promise<Blob> => {
  return Api.get(API_LOAN_NSF_NOTICE, {}, { reversalId }, { responseType: 'blob', timeout: 60000 })
}

export const updateLoanPayment = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_PAYMENT_BY_ID, data, { id })
}

export const deleteLoanPayment = (id: number) => {
  return Api.delete(API_LOAN_PAYMENT_BY_ID, {}, { id })
}

export const getLoanPaymentFillData = (receivedDate?: string, dueDate?: string) => {
  return Api.get(API_LOAN_PAYMENT_FILL, { receivedDate, dueDate })
}

/**
 * Preview the per-participant split a payment would produce, without saving it, so the user can
 * review and edit the distributions before applying. Returns { success, distributions }. Send the
 * edited rows back on createLoanPayment as `participantDistributions` to apply that split.
 *
 * `paymentId` is for an already-applied payment: without it the backend reads the balance as it
 * stands now, which on an applied payoff is zero, and the preview comes back empty. Given the id,
 * it previews on the basis that payment was distributed on (the payment backed out of the UPB and
 * out of each participation's principal paid to date) - the same basis the edited split is
 * reconciled against on PUT. It rides as a query param, so it can never land on a payment column.
 */
export const getLoanPaymentDistributionPreview = (data: Record<string, any>, paymentId?: number) => {
  return Api.post(API_LOAN_PAYMENT_DISTRIBUTION_PREVIEW, data, {}, paymentId ? { params: { paymentId } } : {})
}

export const getLoanPaymentLateChargeCalculation = (receivedDate: string, dueDate: string) => {
  return Api.get(API_LOAN_PAYMENT_LATE_CHARGE_CALCULATION, { receivedDate, dueDate })
}

/**
 * The charges a payoff quoted on `payoffDate` collects, each priced to that date.
 *
 * The payment screen seeds its charge editor from the fill data, which carries no date and so
 * prices every charge to today. A charge with a rate is worth a day less of interest for every day
 * the payoff is backdated, so the screen re-reads this whenever the Payment Received date moves.
 * Its own call rather than a dated refetch of the fill data: that rebuilds the whole screen.
 */
export const getPayoffPaymentCharges = (payoffDate: string) => {
  return Api.get(API_LOAN_PAYMENT_PAYOFF_CHARGES, { payoffDate })
}

/**
 * Whether this tenant can take a payment over the phone. Phone payments key raw card / bank details
 * into our own form, which only the USIO gateway accepts, so the action is hidden otherwise.
 */
export const getPhonePaymentAvailability = () => {
  return Api.get(API_LOAN_PAYMENT_PHONE_AVAILABILITY, {})
}

export interface IPhonePaymentDefaults {
  /** The bank account the loan is enrolled with on its ACH tab, or null when it has none. */
  bank: {
    routingNumber: string
    accountNumber: string
    /** checking | savings */
    accountType: string
    bankName: string
    accountName: string
  } | null
  payor: {
    firstName: string
    lastName: string
    /** One formatted line, which the screen splits into the gateway's address fields. */
    address: string
    email: string
  }
}

/**
 * What the phone-payment screen fills in before staff type anything: the bank account already on
 * the loan's ACH tab, and the borrower's name, address and email.
 */
export const getPhonePaymentDefaults = (): Promise<IPhonePaymentDefaults> => {
  return Api.get(API_LOAN_PAYMENT_PHONE_DEFAULTS, {})
}

/**
 * Quote the gateway's convenience fee and the total the payer will be charged.
 *
 * A card fee is priced from the card's BIN, so the full `cardNumber` has to come along for anything
 * that is not ACH. The response's `method` is the product the fee was quoted under, which is not
 * always the one sent: a debit card at a tenant with pinless debit enabled resolves to that product.
 */
export const getPhonePaymentQuote = (amount: number, method: string, cardNumber?: string) => {
  return Api.post(API_LOAN_PAYMENT_PHONE_QUOTE, { amount, method, cardNumber })
}

/**
 * Charge keyed-in card / ACH details through the gateway and, only if that succeeds, apply the
 * payment to the loan with the supplied allocation. The card / bank numbers are sent straight
 * through to the provider and are never stored on our side.
 */
export const createPhoneLoanPayment = (data: Record<string, any>) => {
  return Api.post(API_LOAN_PAYMENT_PHONE, data)
}

export const downloadLoanPayments = async (format: 'csv' | 'xls' | 'pdf', isSample = false) => {
  const response: Blob = await Api.get(
    API_LOAN_PAYMENT_DOWNLOAD,
    { isSample },
    { format },
    {
      responseType: 'blob',
    },
  )

  downloadFile(isSample ? `Loan Payments Sample.${format}` : `Transaction History.${format}`, response)
}

export const getFciLoanPortfolio = () => {
  return Api.get(API_LOAN_FCI_LOANPORTFOLIO)
}

export const getFciLoanDetail = (servicerNo: number = 0) => {
  return Api.get(API_LOAN_FCI_LOAN_DETAIL, { servicerNo })
}

export const getFciBorrowerPayments = (servicerNo: number = 0) => {
  return Api.get(API_LOAN_FCI_BORROWER_PAYMENTS, { servicerNo })
}

export const getFciOneTimePaymentLink = (servicerNo: number = 0) => {
  return Api.get(API_LOAN_FCI_ONE_TIME_PAYMENT_LINK, { servicerNo })
}

export const getFciCharges = (servicerNo: number = 0) => {
  return Api.get(API_LOAN_FCI_CHARGES, { servicerNo })
}

export const getFciFundingHistory = (servicerNo: number = 0) => {
  return Api.get(API_LOAN_FCI_FUNDING_HISTORY, { servicerNo })
}

export const getFciAttachments = (servicerNo: number = 0) => {
  return Api.get(API_LOAN_FCI_ATTACHMENTS, { servicerNo })
}

export const downloadFciAttachments = (uid: string) => {
  return Api.post(API_LOAN_FCI_DOWNLOAD_ATTACHMENTS, { uid }, {}, { responseType: 'blob', timeout: 150000 })
}

export const getServicngNotesLogs = (key: string) => {
  return Api.get(API_LOAN_GET_SERVICING_NOTES_LOG, {}, { key })
}

export const getLoanCharges = (filters: Record<string, any>) => {
  return Api.get(API_LOAN_CHARGE, filters)
}

/** The charges grid totalled one line per charge type. Takes the grid's own filters, so the two
 * views answer for the same set of charges; `groupBy` keys the buckets on the charge's description
 * (the default) or on its fee category. */
export const getLoanChargeSummary = (filters: Record<string, any>) => {
  return Api.get(API_LOAN_CHARGE_SUMMARY, filters)
}

export const addNewLoanCharge = (data: Record<string, any>) => {
  return Api.post(API_LOAN_CHARGE, data)
}

export const updateLoanCharge = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_CHARGE_UPDATE, data, { id })
}

export const deleteLoanCharge = (id: number) => {
  return Api.delete(API_LOAN_CHARGE_UPDATE, {}, { id })
}

/**
 * Waive what is owed on a charge: it stops being billed or collected, and stays on the loan as the
 * record that the fee was charged and then waived.
 *
 * `amount` forgives that much and leaves the charge billing the rest; omitting it waives the whole
 * of what is left, which is what a waiver has always done.
 */
export const waiveLoanCharge = (id: number, data: { date?: string; reason?: string; amount?: number } = {}) => {
  return Api.put(API_LOAN_CHARGE_WAIVE, data, { id })
}

/** Reverse a waiver, putting everything it forgave back on the charge. */
export const unwaiveLoanCharge = (id: number) => {
  return Api.delete(API_LOAN_CHARGE_WAIVE, {}, { id })
}

/** The configurable fee-category list. `activeOnly` is what the charge picker wants; the admin
 * screen and the filter want retired categories too. */
export const getLoanChargeCategories = (activeOnly = false) => {
  return Api.get(API_LOAN_CHARGE_CATEGORY, activeOnly ? { activeOnly: 'true' } : {})
}

/** Categories actually present on charges, including any dropped from the picker. Takes the grid's
 * own scoping (isLoan / type / owedBy) and carries the 'Uncategorized' bucket when that set holds
 * uncategorized charges; an empty answer means the scope holds no charges at all. The charges
 * filter merges this with the configured list rather than offering it alone - this is what says
 * which retired categories to keep filterable, and whether the rows are categorized yet. */
export const getUsedLoanChargeCategories = (filters: Record<string, any> = {}) => {
  return Api.get(API_LOAN_CHARGE_CATEGORY_USED, filters)
}

export const addLoanChargeCategory = (data: Record<string, any>) => {
  return Api.post(API_LOAN_CHARGE_CATEGORY, data)
}

export const updateLoanChargeCategory = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_CHARGE_CATEGORY_UPDATE, data, { id })
}

/** Everyone a fee split can be paid to. With a loan, each party role also names who holds it and
 * the loan's investors are offered; without one (the category admin) roles are offered as roles. */
export const getChargeSplitPayees = (loanNumber?: number) => {
  return Api.get(API_LOAN_CHARGE_SPLIT_PAYEES, loanNumber ? { loanNumber } : {})
}

/** The lenders a charge on this loan can be booked against: whoever holds a participation, plus the
 * loan's Lender when they hold it without one, plus the wider investor directory. */
export const getLoanChargeLenders = () => {
  return Api.get(API_LOAN_CHARGE_LENDERS, {})
}

export const deleteLoanChargeCategory = (id: number) => {
  return Api.delete(API_LOAN_CHARGE_CATEGORY_UPDATE, {}, { id })
}

/** The rate index catalog: the platform's standard indexes plus the customer's own, each with its
 * latest value. `activeOnly` drops retired ones. */
export const getRateIndexes = (activeOnly = false) => {
  return Api.get(API_RATE_INDEX, activeOnly ? { activeOnly: 'true' } : {})
}

export const addRateIndex = (data: Record<string, any>) => {
  return Api.post(API_RATE_INDEX, data)
}

/** A standard index only takes `isActive`; a custom one takes name, source, description too. */
export const updateRateIndex = (key: string, data: Record<string, any>) => {
  return Api.put(API_RATE_INDEX_UPDATE, data, { key })
}

export const deleteRateIndex = (key: string) => {
  return Api.delete(API_RATE_INDEX_UPDATE, {}, { key })
}

export const getRateIndexValues = (key: string) => {
  return Api.get(API_RATE_INDEX_VALUES, {}, { key })
}

/** Record a value effective from `effectiveDate` (YYYY-MM-DD). Re-entering a date replaces it. */
export const setRateIndexValue = (key: string, data: { effectiveDate: string; value: string | number }) => {
  return Api.post(API_RATE_INDEX_VALUES, data, { key })
}

export const deleteRateIndexValue = (key: string, id: number) => {
  return Api.delete(API_RATE_INDEX_VALUE_DELETE, {}, { key, id })
}

/** Read the standard indexes from the Federal Reserve feed now instead of waiting for the morning run. */
export const syncRateIndexes = () => {
  return Api.post(API_RATE_INDEX_SYNC, {}, {}, { timeout: 150000 })
}

/** What this loan's next rate adjustment would do, read-only: the index value it reads and the new rate. */
export const getArmPreview = () => {
  return Api.get(API_LOAN_ARM_PREVIEW)
}

export const downloadPayoff = (data: Record<string, any>) => {
  return Api.post(API_LOAN_GENERATE_PAYOFF, data, {}, { responseType: 'blob', timeout: 150000 })
}

export const getPayoffLineItems = (data: Record<string, any>) => {
  return Api.post(API_LOAN_PAYOFF_LINE_ITEMS, data)
}

/** The related loans - same property, entity or borrower - a combined payoff can be quoted over. */
export const getCombinedPayoffCandidates = () => {
  return Api.get(API_LOAN_COMBINED_PAYOFF_CANDIDATES)
}

/** Quote several related loans against one good-through date: each loan's figures and the total. */
export const getCombinedPayoffLineItems = (data: Record<string, any>) => {
  return Api.post(API_LOAN_COMBINED_PAYOFF_LINE_ITEMS, data)
}

/** One demand covering every chosen loan, logged on each of them. */
export const downloadCombinedPayoff = (data: Record<string, any>) => {
  return Api.post(API_LOAN_GENERATE_COMBINED_PAYOFF, data, {}, { responseType: 'blob', timeout: 300000 })
}

/** The log of payoff demands already generated on this loan. */
export const getPayoffStatements = () => {
  return Api.get(API_LOAN_PAYOFF_STATEMENTS)
}

/** The stored PDF of one logged statement, exactly as it was generated. */
export const downloadPayoffStatement = (id: number) => {
  return Api.post(API_LOAN_PAYOFF_STATEMENT_PDF, {}, { id }, { responseType: 'blob', timeout: 150000 })
}

/** Approve a statement: stamps the approver and files the PDF into the loan's documents. */
export const approvePayoffStatement = (id: number) => {
  return Api.post(API_LOAN_PAYOFF_STATEMENT_APPROVE, {}, { id })
}

export const deletePayoffStatement = (id: number) => {
  return Api.delete(API_LOAN_PAYOFF_STATEMENT, {}, { id })
}

/**
 * Record that the money for an approved partial release demand has arrived: posts the partial
 * payoff payment, releases that lien and recasts the payment if the demand asked for it.
 *
 * Separate from approving, because a demand goes out days before a closing funds. Comes back with
 * `needsConfirmation` and the warnings when the release is under the configured release price;
 * re-post with `acceptWarnings: true` to go ahead.
 */
export const recordPartialRelease = (id: number, data: Record<string, any>) => {
  return Api.post(API_LOAN_PAYOFF_STATEMENT_RECORD_RELEASE, data, { id })
}

/** The loan's collateral register, seeded from the loan file the first time it is read. */
export const getLoanCollateral = () => {
  return Api.get(API_LOAN_COLLATERAL)
}

export const createLoanCollateral = (data: Record<string, any>) => {
  return Api.post(API_LOAN_COLLATERAL, data)
}

export const updateLoanCollateral = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_COLLATERAL_ITEM, data, { id })
}

export const deleteLoanCollateral = (id: number) => {
  return Api.delete(API_LOAN_COLLATERAL_ITEM, {}, { id })
}

export const downloadReinstatement = (data: Record<string, any>) => {
  return Api.post(API_LOAN_GENERATE_REINSTATEMENT, data, {}, { responseType: 'blob', timeout: 150000 })
}

export const getReinstatementLineItems = (data: Record<string, any>) => {
  return Api.post(API_LOAN_REINSTATEMENT_LINE_ITEMS, data)
}

export const getLoanContacts = (filters: Record<string, any>) => {
  return Api.get(API_LOAN_CONTACT, filters)
}

export const addNewLoanContact = (data: Record<string, any>) => {
  return Api.post(API_LOAN_CONTACT, data)
}

export const updateLoanContact = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_CONTACT_UPDATE, data, { id })
}

export const deleteLoanContact = (id: number) => {
  return Api.delete(API_LOAN_CONTACT_UPDATE, {}, { id })
}

export const getACH = () => {
  return Api.get(API_LOAN_GET_ACH)
}

export const getACHLog = (key: string) => {
  return Api.get(API_LOAN_GET_ACH_LOG, {}, { key })
}

export const postACH = (data: object) => {
  return Api.post(API_LOAN_GET_ACH, data)
}

// Portfolio-wide servicing pages (top-header ACH / Statements)
export const getServicingAchList = (query?: {
  skip?: number
  count?: number
  search?: string
  fromDate?: string
  asOfDate?: string
  idsOnly?: boolean
  orderBy?: string
  orderDir?: string
}) => {
  return Api.get(API_SERVICING_ACH_LIST, query || {})
}

/**
 * The ACH pipeline as a workbook, with what a run over the same window would draft from each loan.
 *
 * The window and the search go to the server rather than the rows held in state, which only ever
 * hold the page on screen, so the sheet is the whole filtered pipeline. Pricing the drafts is a
 * servicing calculation per loan, hence the long timeout.
 */
export const downloadServicingAchListExcel = (query: {
  search?: string
  fromDate?: string
  asOfDate?: string
  effectiveDate?: string
}) => {
  return Api.get(API_SERVICING_ACH_LIST_EXCEL, query, {}, { responseType: 'blob', timeout: 300000 })
}

export const generateAchNacha = (data: { loanNumbers: number[]; effectiveDate?: string }) => {
  return Api.post(API_SERVICING_ACH_NACHA, data)
}

export const getAchConfig = () => {
  return Api.get(API_SERVICING_ACH_CONFIG)
}

export const saveAchConfig = (data: Record<string, any>) => {
  return Api.post(API_SERVICING_ACH_CONFIG, data)
}

// Starts the run; returns { jobId } to poll for progress.
export const processAchRun = (data: {
  loanNumbers?: number[]
  fromDate?: string
  asOfDate: string
  effectiveDate: string
  /**
   * Park every payout these payments raise in the Check Queue instead of leaving it ready to print
   * — for the servicer who does not release the lenders' money until the borrowers' debits have
   * cleared. Without it the payouts are payable the moment the batch is cut.
   */
  holdPayouts?: boolean
  /** When those holds are meant to end (YYYY-MM-DD). Shown in the queue; nothing releases on it. */
  payoutReleaseDate?: string
}) => {
  return Api.post(API_SERVICING_ACH_PROCESS, data)
}

export const getAchProcessStatus = (jobId: string) => {
  return Api.get(API_SERVICING_ACH_PROCESS_STATUS, {}, { jobId })
}

export const getAchPaymentRuns = () => {
  return Api.get(API_SERVICING_ACH_RUNS)
}

// --- Participant payouts ---

/** Distributions owed to participants that are flagged to print and have no reference number yet. */

/** Everyone on the loan who can be paid, with whether ACH is possible for each. */
/** Active defaults for the loan in context. */
export const getServicingDefaults = () => {
  return Api.get(API_LOAN_SERVICING_DEFAULTS)
}

/** Active defaults for a page of loans — used by the pipeline grid. */
export const getServicingDefaultsBulk = (loanNumbers: number[]) => {
  return Api.post(API_LOAN_SERVICING_DEFAULTS_BULK, { loanNumbers })
}

/**
 * The loan's own parties who can be paid — borrower, participants, contractors, the company.
 *
 * `search` also matches the global vendor book, a page at a time: without it no vendors come back,
 * since shipping thousands of them to fill a picker is what made these screens slow to open.
 */
/**
 * Scope every payable call explicitly when a loan number is given, `0` included.
 *
 * `Api` falls back to the loan in context for any falsy `loanNumber`, so a payment that belongs to
 * no loan has to send the string '0' or it would silently attach itself to whichever loan was open
 * last.
 */
const payableScope = (loanNumber?: number | string) =>
  loanNumber != null && loanNumber !== '' && String(loanNumber) !== 'undefined'
    ? { loanNumber: String(loanNumber) }
    : {}

export const getLoanPayees = (loanNumber?: number | string, search = '') => {
  return Api.get(API_LOAN_PAYABLE_PAYEES, search ? { search } : {}, {}, payableScope(loanNumber))
}

/** Payments the loan owes — queued, paid and voided. */
export const getLoanPayables = () => {
  return Api.get(API_LOAN_PAYABLES)
}

/** Payments the loan's own records already justify (credit balance, issued draws). */
export const getPayableSuggestions = (suspenseBalance: number) => {
  return Api.get(API_LOAN_PAYABLE_SUGGESTIONS, { suspenseBalance })
}

/** `loanNumber` raises the payment against another loan than the one in context. */
export const createLoanPayable = (data: Record<string, any>, loanNumber?: number | string) => {
  return postConfirmable(API_LOAN_PAYABLES, data, payableScope(loanNumber))
}

/**
 * Correct a payment that is still queued. Refused once it is paid: by then the check has been
 * issued and the trust ledger written, and putting it back in the queue is a reprint.
 */
export const updateLoanPayable = (id: number, data: Record<string, any>, loanNumber?: number | string) => {
  return Api.put(API_LOAN_PAYABLE_BY_ID, data, { id }, payableScope(loanNumber))
}

export const voidLoanPayable = (id: number) => {
  return Api.delete(API_LOAN_PAYABLE_BY_ID, {}, { id })
}

// --- Payment vouchers: authorize paying a party, approve into the check queue, report on unpaid ---

/** Vouchers on the loan, with payment status reconciled from their payables. */
export const getPaymentVouchers = () => {
  return Api.get(API_PAYMENT_VOUCHERS)
}

export const createPaymentVoucher = (data: Record<string, any>) => {
  return Api.post(API_PAYMENT_VOUCHERS, data)
}

/** Create a construction voucher (a draw payment); forces type/source server-side. */
export const createConstructionVoucher = (data: Record<string, any>) => {
  return Api.post(API_PAYMENT_VOUCHER_CONSTRUCTION, data)
}

export const updatePaymentVoucher = (id: number, data: Record<string, any>) => {
  return Api.put(API_PAYMENT_VOUCHER_BY_ID, data, { id })
}

/** Approve a voucher: creates the payable and drops it into the servicing check queue. */
export const approvePaymentVoucher = (id: number) => {
  return Api.post(API_PAYMENT_VOUCHER_APPROVE, {}, { id })
}

export const rejectPaymentVoucher = (id: number, reason: string) => {
  return Api.post(API_PAYMENT_VOUCHER_REJECT, { reason }, { id })
}

export const voidPaymentVoucher = (id: number) => {
  return Api.delete(API_PAYMENT_VOUCHER_BY_ID, {}, { id })
}

/** Issued construction draws not yet turned into a voucher. */
export const getConstructionVoucherSuggestions = () => {
  return Api.get(API_PAYMENT_VOUCHER_CONSTRUCTION_SUGGESTIONS)
}

/** Download this loan's unpaid-vouchers report (pdf/xls/csv). */
export const downloadUnpaidVouchers = async (format: 'csv' | 'xls' | 'pdf') => {
  const response: Blob = await Api.get(API_PAYMENT_VOUCHER_REPORT, {}, { format }, { responseType: 'blob' })
  downloadFile(`Unpaid Vouchers - ${Api.getLoanNumber()}.${format === 'xls' ? 'xlsx' : format}`, response)
}
/**
 * One page of the check queue. `count: 0` (the default) asks for the whole queue — what
 * "select all in the queue" needs. `count` and `total` in the response always describe the entire
 * queue, not the page returned.
 */
export const getPaymentCheckQueue = (
  params: {
    page?: number
    count?: number
    sortKey?: string
    sortDir?: string
    excludeHold?: boolean
    /**
     * The mirror of `excludeHold`: only the rows parked on hold, which is what the queue's Hold tab
     * reads. `count`/`total` then describe the held set; `heldCount`/`payableCount` come back whole
     * either way, so each tab can label the other.
     */
    onlyHold?: boolean
    /** Free-text filter applied server-side over the whole queue, figures and all. */
    search?: string
    /** Only rows whose loan carries these tags. Server-side, like `search`. */
    tags?: string[]
    /** 'any' (default): the loan carries one of `tags`. 'all': it carries every one. */
    tagMatch?: 'any' | 'all'
    /** Drop rows whose loan carries any of these tags. */
    excludeTags?: string[]
  } = {},
) => {
  // Empty tag arrays are dropped rather than sent: `tags[]=` reaches the server as a one-element
  // array holding an empty string, which reads as a filter that nothing can satisfy.
  const { tags, excludeTags, ...rest } = params
  return Api.get(API_PAYMENT_CHECK_QUEUE, {
    ...rest,
    ...(tags?.length ? { tags } : {}),
    ...(excludeTags?.length ? { excludeTags } : {}),
  })
}

/**
 * The check queue as a workbook, for reading a batch over before it is paid.
 *
 * `keys` is the screen's selection (`d<id>` / `p<id>`), which is the usual case: export what is
 * ticked. Sent without `keys`, everything matching comes back, narrowed by the hold scope, the
 * `search` and the tag filter passed alongside it, which is the set the screen is showing.
 */
export const downloadCheckQueueExcel = (data: {
  keys?: string[]
  /** The tab's scope, for an export with no selection. Ignored when `keys` are sent. */
  excludeHold?: boolean
  onlyHold?: boolean
  search?: string
  tags?: string[]
  tagMatch?: 'any' | 'all'
  excludeTags?: string[]
  sortKey?: string
  sortDir?: string
}) => {
  return Api.post(API_PAYMENT_CHECK_QUEUE_EXCEL, data, {}, { responseType: 'blob', timeout: 120000 })
}

/**
 * Park queued rows so a "select all" passes over them, or let them go again. Held rows stay in the
 * queue and in its headline figures — holding is not a way out of the queue, it is a way to see
 * what is being kept back.
 */
export const setPaymentCheckHold = (data: {
  distributionIds?: number[]
  payableIds?: number[]
  hold: boolean
  /**
   * When the hold is meant to end (YYYY-MM-DD), or omitted for a hold with no date. Recorded and
   * shown in the queue, where the search also looks inside it; nothing ever releases on it.
   * Ignored when releasing.
   */
  releaseDate?: string
}) => {
  return Api.post(API_PAYMENT_CHECK_HOLD, data)
}

/** Pay selected queued rows — handwritten check numbers, or a generated ACH credit batch. */
export const payPaymentChecks = (data: {
  distributionIds: number[]
  method: 'check' | 'ach'
  payableIds?: number[]
  checkNumbers?: Record<number, string>
  payableCheckNumbers?: Record<number, string>
  startingCheckNumber?: string
  effectiveDate?: string
  /** The day the money went out (YYYY-MM-DD) — the run's date and the paid date on what it pays. */
  runDate?: string
  groupByPayee?: boolean
}) => {
  return Api.post(API_PAYMENT_CHECK_PAY, data, {}, { timeout: 120000 })
}

/**
 * Correct the date a run went out on. The paid dates and ledger postings it stamped move with it;
 * the reference numbers written on the checks do not change.
 */
export const setPaymentRunDate = (id: number, runDate: string) => {
  return Api.post(API_PAYMENT_CHECK_RUN_DATE, { id, runDate })
}

export const getPaymentCheckRuns = () => {
  return Api.get(API_PAYMENT_CHECK_RUNS)
}

/** Line-by-line detail of what went out under one check / ACH reference. */
export const getPaymentRemittance = (reference: string, runId?: number) => {
  return Api.get(API_PAYMENT_CHECK_REMITTANCE, runId ? { reference, runId } : { reference })
}

export const downloadPaymentRunNacha = (data: { id: number }) => {
  return Api.post(API_PAYMENT_CHECK_RUN_DOWNLOAD, data, {}, { responseType: 'blob', timeout: 60000 })
}

/** Whether ACH payout runs can be sent to a payment provider, and its disbursement balance. */
export const getPaymentCheckProvider = () => {
  return Api.get(API_PAYMENT_CHECK_PROVIDER)
}

/** Send an ACH payout run to the payment provider as ACH credits. Retries only re-send failures. */
export const submitPaymentRunToProvider = (id: number) => {
  return Api.post(API_PAYMENT_CHECK_RUN_SUBMIT_PROVIDER, { id }, {}, { timeout: 120000 })
}

/** Processed/failed breakdown of one payout run. */
export const getPaymentRunReport = (id: number) => {
  return Api.get(API_PAYMENT_CHECK_RUN_REPORT_DATA, {}, { id })
}

/** Printable PDF of one payout run. */
export const downloadPaymentRunReport = (data: { id: number }) => {
  return Api.post(API_PAYMENT_CHECK_RUN_REPORT, data, {}, { responseType: 'blob', timeout: 60000 })
}

/** The same run as a workbook: the payments, plus a line per item paid with its loan's identity. */
export const downloadPaymentRunExcel = (data: { id: number }) => {
  return Api.post(API_PAYMENT_CHECK_RUN_EXCEL, data, {}, { responseType: 'blob', timeout: 60000 })
}

/** The run's checks laid out for preprinted QuickBooks stock, or one sample check to align on. */
export const printPaymentRunChecks = (data: {
  id?: number
  layout?: 'standard' | 'voucher'
  offsetX?: number
  offsetY?: number
  startPosition?: number
  references?: string[]
  sample?: boolean
}) => {
  return Api.post(API_PAYMENT_CHECK_RUN_PRINT, data, {}, { responseType: 'blob', timeout: 60000 })
}

/** Return the run's distributions to the check queue but keep the run in history. */
export const reversePaymentRun = (id: number) => {
  return Api.post(API_PAYMENT_CHECK_RUN_REVERSE, { id })
}

/** Who a run's Notice of Deposit would go to, and whether each payee can be emailed. */
export const getDepositNotices = (id: number) => {
  return Api.get(API_PAYMENT_CHECK_DEPOSIT_NOTICES, {}, { id })
}

/** Email a Notice of Deposit to each payee in the run — optionally limited to specific references. */
export const sendDepositNotices = (id: number, references?: string[]) => {
  return Api.post(API_PAYMENT_CHECK_DEPOSIT_NOTICES_SEND, references?.length ? { references } : {}, { id })
}

/** Who an ACH DEBIT run draws from, and whether each can be emailed a Notice of Electronic Debit. */
export const getDebitNotices = (id: number) => {
  return Api.get(API_ACH_RUN_DEBIT_NOTICES, {}, { id })
}

/** Email a Notice of Electronic Debit to each payer in the run — optionally limited to specific references. */
export const sendDebitNotices = (id: number, references?: string[]) => {
  return Api.post(API_ACH_RUN_DEBIT_NOTICES_SEND, references?.length ? { references } : {}, { id })
}

/** Whether notices go out on their own when a run is committed, one switch per money-movement kind. */
export const getDepositNoticeConfig = () => {
  return Api.get(API_DEPOSIT_NOTICE_CONFIG)
}

export const setDepositNoticeConfig = (data: {
  autoSendPayouts?: boolean
  autoSendFundPayouts?: boolean
  autoSendDebits?: boolean
}) => {
  return Api.post(API_DEPOSIT_NOTICE_CONFIG, data)
}

/** Delete the run, returning its distributions to the queue unless already reversed. */
export const deletePaymentRun = (id: number) => {
  return Api.delete(API_PAYMENT_CHECK_RUN_DELETE, {}, { id })
}

/** Void a paid check and put the distribution back into the queue to be reissued. */
export const reprintPaymentCheck = (distributionId: number) => {
  return Api.post(API_PAYMENT_CHECK_REPRINT, { distributionId })
}

/** Reprint a payable (a vendor, contractor or borrower payout) rather than a distribution. */
export const reprintPayableCheck = (payableId: number) => {
  return Api.post(API_PAYMENT_CHECK_REPRINT, { payableId })
}

/**
 * Record that the bank sent a payout back. Not the same thing as a reprint: the payment stands and
 * a deposit books the money's return, with `reissue` queueing a copy to pay again.
 */
export const returnPayoutCheck = (data: {
  payableId: number
  returnedDate?: string
  reason?: string
  reissue?: boolean
}) => {
  return Api.post(API_PAYMENT_CHECK_RETURNED, data)
}

/** Undo a return keyed in by mistake, putting the payment back to paid. */
export const undoPayoutReturn = (payableId: number) => {
  return Api.delete(API_PAYMENT_CHECK_RETURNED_UNDO, {}, { payableId })
}

export const downloadAchRunNacha = (data: { id: number }) => {
  return Api.post(API_SERVICING_ACH_RUN_DOWNLOAD, data, {}, { responseType: 'blob', timeout: 60000 })
}

/** Whether ACH runs can be transmitted to a payment provider. */
export const getAchProvider = () => {
  return Api.get(API_SERVICING_ACH_PROVIDER)
}

/** ACH entries the provider reported as returned. */
export const getAchReturns = (status?: string) => {
  return Api.get(API_SERVICING_ACH_RETURNS, status ? { status } : {})
}

/** Poll the provider for returns now rather than waiting for the nightly sweep. */
export const sweepAchReturns = (days?: number) => {
  return Api.post(API_SERVICING_ACH_RETURNS_SWEEP, days ? { days } : {}, {}, { timeout: 120000 })
}

/** Reverse the returned draft (fee only when the code warrants it), or requeue a returned payout. */
export const applyAchReturn = (id: number) => {
  return Api.post(API_SERVICING_ACH_RETURNS_APPLY, { id }, {}, { timeout: 120000 })
}

/** Dismiss a return without acting on it. */
export const ignoreAchReturn = (id: number, reason?: string) => {
  return Api.post(API_SERVICING_ACH_RETURNS_IGNORE, reason ? { id, reason } : { id })
}

/** Send an ACH draft run to the payment provider as ACH debits. Retries only re-send failures. */
export const submitAchRunToProvider = (id: number) => {
  return Api.post(API_SERVICING_ACH_RUN_SUBMIT_PROVIDER, { id }, {}, { timeout: 120000 })
}

export const downloadAchRunReport = (data: { id: number }) => {
  return Api.post(API_SERVICING_ACH_RUN_REPORT, data, {}, { responseType: 'blob', timeout: 60000 })
}

/** The run as a workbook: the drafts, plus a line per piece of each draft with its GL account. */
export const downloadAchRunExcel = (data: { id: number }) => {
  return Api.post(API_SERVICING_ACH_RUN_EXCEL, data, {}, { responseType: 'blob', timeout: 60000 })
}

export const getAchRunReport = (id: number) => {
  return Api.get(API_SERVICING_ACH_RUN_REPORT_DATA, {}, { id })
}

export const reverseAchRun = (id: number) => {
  return Api.post(API_SERVICING_ACH_RUN_REVERSE, { id })
}

export const deleteAchRun = (id: number) => {
  return Api.delete(API_SERVICING_ACH_RUN_DELETE, {}, { id })
}

export const getServicingStatements = () => {
  return Api.get(API_SERVICING_STATEMENTS)
}

export const generateServicingStatements = (data: {
  periodStart: string
  periodEnd: string
  statementDate: string
  loanNumbers: number[]
  emailNow: boolean
  portalVisible?: boolean
  tags?: string[]
  tagMatch?: TagMatch
  excludeTags?: string[]
  excludeInterestTypes?: string[]
  /** Which statement types to generate. EMPTY MEANS EVERY TYPE. */
  statementTypes?: string[]
  /** Re-statement loans that already have a statement for this statement date. */
  allowDuplicates?: boolean
}) => {
  return Api.post(API_SERVICING_STATEMENTS_GENERATE, data)
}

export const getStatementGenerationStatus = (jobId: string) => {
  return Api.get(API_SERVICING_STATEMENTS_GENERATE_STATUS, {}, { jobId })
}

/** Call off a statement run. It stops between loans; the statements already generated are kept. */
export const cancelStatementGeneration = (jobId: string) => {
  return Api.post(API_SERVICING_STATEMENTS_GENERATE_CANCEL, {}, { jobId })
}

// --- Servicing > Tax Forms: the portfolio-wide IRS Form 1098 run ---

export interface TaxFormRunData {
  year: number
  /** Omit or leave empty for the whole servicing book. */
  loanNumbers?: number[]
  /** Interest floor; the backend defaults to the $600 IRS filing threshold. */
  minInterest?: number
  portalVisible?: boolean
  emailNow?: boolean
  includeOriginationFee?: boolean
  includeDiscountPoints?: boolean
  tags?: string[]
  tagMatch?: TagMatch
  excludeTags?: string[]
}

/**
 * Who needs a 1098 for this tax year. Read-only: it generates nothing, so it is safe to call as
 * the year or the threshold is changed.
 */
export const getTaxFormCandidates = (data: Partial<TaxFormRunData> & { year: number }) => {
  return Api.post(API_SERVICING_TAX_FORM_CANDIDATES, data)
}

export const generateTaxForms = (data: TaxFormRunData) => {
  return Api.post(API_SERVICING_TAX_FORMS_GENERATE, data)
}

export const getTaxFormGenerationStatus = (jobId: string) => {
  return Api.get(API_SERVICING_TAX_FORMS_GENERATE_STATUS, {}, { jobId })
}

/** Call off a 1098 run. It stops between loans; the forms already sent are kept. */
export const cancelTaxFormGeneration = (jobId: string) => {
  return Api.post(API_SERVICING_TAX_FORMS_GENERATE_CANCEL, {}, { jobId })
}

export const getTaxFormBatches = () => {
  return Api.get(API_SERVICING_TAX_FORM_BATCHES)
}

export const getBatchTaxForms = (id: number) => {
  return Api.get(API_SERVICING_TAX_FORM_BATCH, {}, { id })
}

/** Email the forms in a batch that have not gone out yet. Already-emailed forms are skipped. */
export const emailTaxFormBatch = (id: number) => {
  return Api.post(API_SERVICING_TAX_FORM_BATCH_EMAIL, { id })
}

export const emailTaxForm = (id: number) => {
  return Api.post(API_SERVICING_TAX_FORM_EMAIL, { id })
}

export const downloadTaxForm = async (id: number, fileName: string) => {
  const res: Blob = await Api.post(API_SERVICING_TAX_FORM_DOWNLOAD, { id }, {}, { responseType: 'blob' })
  downloadFile(fileName, res)
}

export const getLoanTaxForms = (loanNumber: number) => {
  return Api.get(API_SERVICING_TAX_FORMS_LOAN, {}, { loanNumber })
}

/** One stored 1098 with the figures behind it, which the batch listing leaves off. */
export const getTaxForm = (id: number) => {
  return Api.get(API_SERVICING_TAX_FORM, {}, { id })
}

/**
 * Hand-edit a stored 1098 and re-render it.
 *
 * Money arrives as a number: the stored figures keep a raw and a formatted copy of each box and
 * the backend writes both, so sending a formatted string would put "$1,200.00" where a number
 * belongs.
 */
export const updateTaxForm = (id: number, data: Record<string, any>) => {
  return Api.put(API_SERVICING_TAX_FORM, data, { id })
}

export const emailServicingStatement = (data: { id: number }) => {
  return Api.post(API_SERVICING_STATEMENT_EMAIL, data)
}

export const downloadServicingStatement = (data: { id: number }) => {
  return Api.post(API_SERVICING_STATEMENT_DOWNLOAD, data, {}, { responseType: 'blob', timeout: 150000 })
}

// Generate a statement PDF for a single loan on demand (pipeline grid action).
export const generateLoanStatement = (loanNumber: number) => {
  return Api.post(API_SERVICING_STATEMENT_GENERATE_ONE, {}, { loanNumber }, { responseType: 'blob', timeout: 150000 })
}

// One loan's stored statements, for the loan file's Statements screen.
export const getLoanStatements = (loanNumber: number) => {
  return Api.get(API_SERVICING_STATEMENTS_LOAN, {}, { loanNumber })
}

// Print a statement from the loan file and keep it (stored, attached to the loan, optionally emailed).
export const printLoanStatement = (
  loanNumber: number,
  data: { periodStart: string; periodEnd: string; statementDate: string; emailNow: boolean; portalVisible: boolean },
) => {
  return Api.post(API_SERVICING_STATEMENTS_LOAN, data, { loanNumber }, { timeout: 150000 })
}

export const getStatementSchedule = () => {
  return Api.get(API_SERVICING_STATEMENT_SCHEDULE)
}

export const saveStatementSchedule = (data: {
  frequency: Record<string, any>
  emailNow: boolean
  portalVisible: boolean
  enabled: boolean
  // The loan-selection rule the schedule runs with. Saved on the schedule so a scheduled run
  // selects the same loans a manual run with the same filter would.
  tags: string[]
  tagMatch: string
  excludeTags: string[]
  excludeInterestTypes: string[]
  statementTypes?: string[]
}) => {
  return Api.put(API_SERVICING_STATEMENT_SCHEDULE, data)
}

export const runStatementScheduleNow = () => {
  return Api.post(API_SERVICING_STATEMENT_SCHEDULE_RUN, {}, {}, { timeout: 0 })
}

/**
 * What a statement schedule holds. `statementTypes` is the type scope: which of the payment,
 * construction and line-of-credit statements this run generates.
 *
 * ⚠️ An EMPTY `statementTypes` means EVERY type, not none, so a schedule saved before the split
 * keeps statementing the whole book.
 */
export type StatementScheduleData = {
  id?: number
  name?: string
  frequency: Record<string, any>
  emailNow: boolean
  portalVisible: boolean
  enabled: boolean
  // The loan-selection rule the schedule runs with. Saved on the schedule so a scheduled run
  // selects the same loans a manual run with the same filter would.
  tags: string[]
  tagMatch: string
  excludeTags: string[]
  excludeInterestTypes: string[]
  statementTypes: string[]
  lastRunDate?: string
}

/** Every saved schedule. A tenant may bill each statement type on its own date. */
export const getStatementSchedules = () => {
  return Api.get(API_SERVICING_STATEMENT_SCHEDULES)
}

export const createStatementSchedule = (data: StatementScheduleData) => {
  return Api.post(API_SERVICING_STATEMENT_SCHEDULES, data)
}

export const updateStatementSchedule = (id: number, data: StatementScheduleData) => {
  return Api.put(API_SERVICING_STATEMENT_SCHEDULE_BY_ID, data, { id })
}

export const deleteStatementSchedule = (id: number) => {
  return Api.delete(API_SERVICING_STATEMENT_SCHEDULE_BY_ID, {}, { id })
}

/** Run one schedule now. `timeout: 0` because a book-wide run outlives any default. */
export const runStatementScheduleById = (id: number) => {
  return Api.post(API_SERVICING_STATEMENT_SCHEDULE_BY_ID_RUN, {}, { id }, { timeout: 0 })
}

export const getAchSchedule = () => {
  return Api.get(API_SERVICING_ACH_SCHEDULE)
}

export const saveAchSchedule = (data: { frequency: Record<string, any>; enabled: boolean }) => {
  return Api.put(API_SERVICING_ACH_SCHEDULE, data)
}

export const runAchScheduleNow = () => {
  return Api.post(API_SERVICING_ACH_SCHEDULE_RUN, {}, {}, { timeout: 0 })
}

export const getStatementBatches = () => {
  return Api.get(API_SERVICING_STATEMENT_BATCHES)
}

export const getBatchStatements = (id: number) => {
  return Api.get(API_SERVICING_STATEMENT_BATCH, {}, { id })
}

export const downloadStatementBatch = (data: { id: number }) => {
  return Api.post(API_SERVICING_STATEMENT_BATCH_DOWNLOAD, data, {}, { responseType: 'blob', timeout: 150000 })
}

export const emailStatementBatch = (data: { id: number }) => {
  return Api.post(API_SERVICING_STATEMENT_BATCH_EMAIL, data)
}

/**
 * Withdraw a statement that should not have gone out. It goes from the loan's stored statements,
 * from the loan documents and from the borrower portal; an email already sent stays sent.
 */
export const deleteServicingStatement = (id: number) => {
  return Api.delete(API_SERVICING_STATEMENT_DELETE, {}, { id })
}

// The same, for a whole run: every statement in the batch, then the batch itself.
export const deleteStatementBatch = (id: number) => {
  return Api.delete(API_SERVICING_STATEMENT_BATCH_DELETE, {}, { id }, { timeout: 0 })
}

export const getPenalty = () => {
  return Api.get(API_LOAN_PENALTY)
}

export const postPenalty = (data: object) => {
  return Api.post(API_LOAN_PENALTY, data)
}

export const getOrderOuts = () => {
  return Api.get(API_LOAN_GET_ORDER_OUTS)
}

export const postOrderOuts = (data: object) => {
  return Api.post(API_LOAN_GET_ORDER_OUTS, data)
}

export const addNewInvestor = (data: Record<string, any>) => {
  return Api.post(API_LOAN_INVESTOR, data)
}

export const getLoanInvestors = () => {
  return Api.get(API_LOAN_INVESTOR)
}

export const updateLoanInvestor = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_INVESTOR_UPDATE, data, { id })
}

export const deleteLoanInvestor = (id: number) => {
  return Api.delete(API_LOAN_INVESTOR_UPDATE, {}, { id })
}

export const generateOrderOut = async (loanNumber: number, title: string, byteproFileName: number) => {
  const response: Blob = await Api.post(
    API_LOAN_GET_ORDER_OUTS_DOWNLOAD,
    { title },
    {},
    {
      responseType: 'blob',
    },
  )

  downloadFile(`${title} - ${getLoanDisplayNo({ byteproFileName, loanNumber })}.pdf`, response)
}

export const generateOrderOutCheckPlaceholder = async (loanNumber: number, title: string) => {
  return await Api.post(
    API_LOAN_GET_ORDER_OUTS_CHECK_PLACEHOLDER,
    { title },
    {},
    {
      timeout: 150000,
    },
  )
}

export const sendOrderOutEmail = (title: string, emailData: Record<string, string>, data: Record<string, any>) => {
  return Api.post(API_LOAN_SEND_ORDER_OUT_EMAIL, { title, emailData, data })
}

export interface AgingRange {
  start: number
  end: number | null
}

export const getServicingReport = () => {
  return Api.get(API_LOAN_SERVICING_REPORT)
}

export const saveServicingReport = (data: { agingMatrix: AgingRange[] }) => {
  return Api.post(API_LOAN_SERVICING_REPORT, data)
}

export const downloadTaxForms = async (data: {
  year: number
  includeOriginationFee: boolean
  includeDiscountPoints: boolean
}) => {
  const res: Blob = await Api.post(
    API_LOAN_DOWNLOAD_TAX_FORMS,
    data,
    {},
    {
      responseType: 'blob',
    },
  )

  downloadFile(`1098-forms-${data.year}.pdf`, res)
}

/** Vouchers: what the loan owes out, with amounts and due dates. */
export const getLoanVouchers = () => {
  return Api.get(API_LOAN_VOUCHERS)
}

export const createLoanVoucher = (data: Record<string, any>) => {
  return Api.post(API_LOAN_VOUCHERS, data)
}

export const updateLoanVoucher = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_VOUCHER_BY_ID, data, { id })
}

/** Deactivates rather than deletes, so a past escrow analysis stays reproducible. */
export const deactivateLoanVoucher = (id: number) => {
  return Api.delete(API_LOAN_VOUCHER_BY_ID, {}, { id })
}

/** Anticipated escrow disbursements over a computation year. */
export const getLoanVoucherProjection = (params: { startDate: string; months: number }) => {
  return Api.get(API_LOAN_VOUCHER_PROJECTION, params)
}

/** The escrow balance and monthly payment a new analysis starts from, per servicing information. */
export const getEscrowAnalysisDefaults = () => {
  return Api.get(API_LOAN_ESCROW_ANALYSIS_DEFAULTS)
}

/** Try an escrow analysis without storing it, so settings can be adjusted first. */
export const previewEscrowAnalysis = (params: Record<string, any>) => {
  return Api.post(API_LOAN_ESCROW_ANALYSIS_PREVIEW, params)
}

/** Run and keep an escrow analysis, so the borrower's statement stays reproducible. */
export const runEscrowAnalysis = (params: Record<string, any>) => {
  return Api.post(API_LOAN_ESCROW_ANALYSIS, params)
}

export const getEscrowAnalyses = () => {
  return Api.get(API_LOAN_ESCROW_ANALYSIS)
}

/** The borrower's Annual Escrow Account Disclosure Statement for one saved analysis. */
export const downloadEscrowStatement = async (id: number) => {
  const response: Blob = await Api.get(API_LOAN_ESCROW_ANALYSIS_STATEMENT, {}, { id }, { responseType: 'blob' })
  downloadFile(`Escrow Analysis - ${Api.getLoanNumber()}.pdf`, response)
}

/** Many statements in one PDF, for an annual run. */
export const downloadEscrowStatements = async (analysisIds: number[]) => {
  const response: Blob = await Api.post(
    API_LOAN_ESCROW_ANALYSIS_STATEMENTS,
    { analysisIds },
    {},
    { responseType: 'blob' },
  )
  downloadFile('Escrow Statements.pdf', response)
}

// --- Borrower portal (staff side): secure messages + payment reconcile queue ---
// Loan is scoped by the loan-number header (Api attaches it automatically).
const API_SERVICING_BORROWER_MESSAGES = '/loan/servicing/messages'
const API_SERVICING_BORROWER_MESSAGES_UNREAD = '/loan/servicing/messages/unread'
const API_SERVICING_BORROWER_PAYMENTS = '/loan/servicing/borrowerPayments'
const API_SERVICING_BORROWER_PAYMENT_RECONCILE = '/loan/servicing/borrowerPayments/:id/reconcile'

export const getServicingBorrowerMessages = (): Promise<{ messages: any[] }> => {
  return Api.get(API_SERVICING_BORROWER_MESSAGES)
}

export const getServicingBorrowerMessagesUnread = (): Promise<{ count: number }> => {
  return Api.get(API_SERVICING_BORROWER_MESSAGES_UNREAD)
}

export const replyServicingBorrowerMessage = (body: string) => {
  return Api.post(API_SERVICING_BORROWER_MESSAGES, { body })
}

export const getServicingBorrowerPayments = (): Promise<any[]> => {
  return Api.get(API_SERVICING_BORROWER_PAYMENTS)
}

export const reconcileServicingBorrowerPayment = (id: number, loanPaymentId?: number) => {
  return Api.post(API_SERVICING_BORROWER_PAYMENT_RECONCILE, { loanPaymentId }, { id })
}

// --- Borrower text messages (SMS) ---
// Loan is scoped by the loan-number header (Api attaches it automatically).
const API_SERVICING_TEXT_MESSAGES = '/loan/servicing/textMessages'
const API_SERVICING_TEXT_MESSAGES_UNREAD = '/loan/servicing/textMessages/unread'
const API_SERVICING_TEXT_MESSAGES_STREAM = '/loan/servicing/textMessages/stream'
const API_SERVICING_TEXT_MESSAGES_INBOX = '/loan/servicing/textMessages/inbox'
const API_SERVICING_TEXT_MESSAGES_INVITE = '/loan/servicing/textMessages/invite'
const API_SERVICING_TEXT_MESSAGES_INVITE_ALL = '/loan/servicing/textMessages/inviteAll'
const API_SERVICING_TEXT_MESSAGES_OPT_IN = '/loan/servicing/textMessages/optIn'

export const getLoanTextMessages = (): Promise<any> => {
  return Api.get(API_SERVICING_TEXT_MESSAGES)
}

export const getLoanTextMessagesUnread = (): Promise<{ count: number }> => {
  return Api.get(API_SERVICING_TEXT_MESSAGES_UNREAD)
}

/** Base delay between reconnect attempts; doubles up to STREAM_RETRY_MAX_MS. */
const STREAM_RETRY_MS = 2000
const STREAM_RETRY_MAX_MS = 30000

/**
 * Subscribe to live text-message activity for a loan.
 *
 * Server-Sent Events rather than a websocket: nginx streams this through untouched, so it needs no
 * upgrade configuration on the tenant vhosts. Uses fetch rather than EventSource because the JWT
 * goes in the Authorization header, the same way the assistant's status stream works.
 *
 * Returns a function that closes the stream and stops it reconnecting.
 */
export const streamLoanTextMessages = (
  loanNumber: string,
  handlers: { onActivity: () => void; onOpen?: () => void; onClose?: () => void },
) => {
  let stopped = false
  let controller: AbortController | null = null
  let retryTimer: any = null
  let retryDelay = STREAM_RETRY_MS

  const connect = async () => {
    if (stopped) return
    controller = new AbortController()
    try {
      const token = store.getState()?.auth?.token
      const res = await fetch(`${appApiUrl}${API_SERVICING_TEXT_MESSAGES_STREAM}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token || ''}`,
          'loan-number': loanNumber || '',
        },
        signal: controller.signal,
      })
      if (!res.ok || !res.body) throw new Error(`Text message stream failed (${res.status})`)

      const reader = res.body.getReader()
      const decoder = new TextDecoder()
      let buffer = ''

      for (;;) {
        const { done, value } = await reader.read()
        if (done) break
        buffer += decoder.decode(value, { stream: true })
        // SSE frames are separated by a blank line; comments (": ping") carry no data field.
        const frames = buffer.split('\n\n')
        buffer = frames.pop() || ''
        frames.forEach((frame) => {
          const line = frame.split('\n').find((l) => l.startsWith('data:'))
          if (!line) return
          try {
            const event = JSON.parse(line.slice(5).trim())
            if (event?.type === 'ready') {
              // The connection is good, so a later drop starts its backoff from the bottom again.
              retryDelay = STREAM_RETRY_MS
              handlers.onOpen?.()
            } else if (event?.type === 'activity') handlers.onActivity()
          } catch {
            // A partial or malformed frame is not worth tearing the stream down for.
          }
        })
      }
    } catch {
      // Network drop, tab sleep, deploy: fall through to the retry below.
    }

    if (stopped) return
    handlers.onClose?.()
    retryTimer = setTimeout(connect, retryDelay)
    retryDelay = Math.min(retryDelay * 2, STREAM_RETRY_MAX_MS)
  }

  connect()

  return () => {
    stopped = true
    clearTimeout(retryTimer)
    controller?.abort()
  }
}

/** Every borrower conversation with an inbound message, across loans. */
export const getTextMessageInbox = (unreadOnly = false) => {
  return Api.get(API_SERVICING_TEXT_MESSAGES_INBOX, { unreadOnly })
}

export const sendLoanTextMessage = (phone: string, body: string) => {
  return Api.post(API_SERVICING_TEXT_MESSAGES, { phone, body })
}

/** Email one borrower an invitation to opt in to text messages. */
export const inviteLoanTextMessageOptIn = (phone: string, channel: 'email' | 'text' = 'email') => {
  return Api.post(API_SERVICING_TEXT_MESSAGES_INVITE, { phone, channel })
}

/** Preview (default) or send the invitation to every borrower who has not opted in. */
export const inviteAllTextMessageOptIn = (preview = true) => {
  return Api.post(API_SERVICING_TEXT_MESSAGES_INVITE_ALL, { preview })
}

export interface ITextMessageOptIn {
  name: string
  phoneDisplay: string
  disclosure: string
  consented: boolean
  consentedAt: string | null
  optedOut: boolean
  fromNumber: string
}

/**
 * The opt-in page reached from the agree button in an invitation email.
 *
 * Both calls are authorized by the temporary token in the URL, which the layout has already put on
 * the request - the borrower has no account to sign in to. Neither call names a phone number: it
 * comes from the signed token, so a forwarded link cannot opt somebody else in.
 */
export const getTextMessageEmailOptIn = (): Promise<ITextMessageOptIn> => {
  return Api.get(API_SERVICING_TEXT_MESSAGES_OPT_IN)
}

export const acceptTextMessageEmailOptIn = (): Promise<{ consented: boolean }> => {
  return Api.post(API_SERVICING_TEXT_MESSAGES_OPT_IN)
}

// --- Cross-loan Online Payments (portfolio view + apply) ---
const API_SERVICING_ONLINE_PAYMENTS = '/loan/servicing/online-payments'
const API_SERVICING_ONLINE_PAYMENTS_APPLIED = '/loan/servicing/online-payments/applied'
const API_SERVICING_ONLINE_PAYMENT_APPLY = '/loan/servicing/online-payments/:id/apply'
const API_SERVICING_ONLINE_PAYMENTS_APPLY_ALL = '/loan/servicing/online-payments/apply-all-matching'
const API_SERVICING_ONLINE_PAYMENTS_REFRESH = '/loan/servicing/online-payments/refresh'

export const getOnlinePayments = (): Promise<any[]> => {
  return Api.get(API_SERVICING_ONLINE_PAYMENTS)
}

export const getAppliedOnlinePayments = (): Promise<any[]> => {
  return Api.get(API_SERVICING_ONLINE_PAYMENTS_APPLIED)
}

export const applyOnlinePayment = (id: number, mode: 'automatic' | 'manual', allocation?: Record<string, any>) => {
  return Api.post(API_SERVICING_ONLINE_PAYMENT_APPLY, { mode, allocation }, { id })
}

export const applyAllMatchingOnlinePayments = () => {
  return Api.post(API_SERVICING_ONLINE_PAYMENTS_APPLY_ALL)
}

/** Re-ask the payment provider about every payment still shown as processing (ACH has no webhook). */
export const refreshOnlinePayments = (): Promise<{ checked: number; settled: number }> => {
  return Api.post(API_SERVICING_ONLINE_PAYMENTS_REFRESH)
}

// --- Collections calls and promises to pay ---
const API_LOAN_COLLECTION_CALL = '/loan/collectionCall'
const API_LOAN_COLLECTION_CALL_BY_ID = '/loan/collectionCall/:id'
const API_LOAN_COLLECTION_CALL_RELEASE = '/loan/collectionCall/:id/releaseToSweep'
const API_LOAN_COLLECTION_CALL_OUTCOMES = '/loan/collectionCall/outcomes'
const API_SERVICING_COLLECTIONS = '/loan/servicing/collections'
const API_SERVICING_COLLECTIONS_PROMISES = '/loan/servicing/collections/promises'
const API_SERVICING_COLLECTIONS_SWEEP = '/loan/servicing/collections/sweep'

/** The fixed outcome list, served by the API so its labels can never drift from the stored values. */
export const getCollectionCallOutcomes = (): Promise<{ value: string; label: string }[]> => {
  return Api.get(API_LOAN_COLLECTION_CALL_OUTCOMES)
}

export const getCollectionCalls = (filters: Record<string, any>) => {
  return Api.get(API_LOAN_COLLECTION_CALL, filters)
}

export const addCollectionCall = (data: Record<string, any>) => {
  return Api.post(API_LOAN_COLLECTION_CALL, data)
}

export const updateCollectionCall = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_COLLECTION_CALL_BY_ID, data, { id })
}

export const deleteCollectionCall = (id: number) => {
  return Api.delete(API_LOAN_COLLECTION_CALL_BY_ID, {}, { id })
}

/**
 * Give a promise a person had ruled on back to the nightly sweep. Its date and amount are left
 * alone: before this existed, re-arming the sweep meant editing the promised terms.
 */
export const releasePromiseToSweep = (id: number) => {
  return Api.put(API_LOAN_COLLECTION_CALL_RELEASE, {}, { id })
}

/** Calls across the whole book (the collections queue's Calls tab). */
export const getCollectionsQueue = (filters: Record<string, any>) => {
  return Api.get(API_SERVICING_COLLECTIONS, filters)
}

/** Promises to pay across the whole book, open ones by default. */
export const getPromisesToPay = (filters: Record<string, any>) => {
  return Api.get(API_SERVICING_COLLECTIONS_PROMISES, filters)
}

/** Settle open promises now rather than waiting for tonight's pass. */
export const sweepPromisesToPay = (data: { asOf?: string } = {}) => {
  return Api.post(API_SERVICING_COLLECTIONS_SWEEP, data)
}

// --- The foreclosure book: every loan in the legal process and where it stands ---
const API_SERVICING_FORECLOSURE_QUEUE = '/loan/servicing/foreclosure/queue'
const API_SERVICING_FORECLOSURE_QUEUE_SUMMARY = '/loan/servicing/foreclosure/queue/summary'
const API_SERVICING_FORECLOSURE_STAGES = '/loan/servicing/foreclosure/stages'

export const getForeclosureQueue = (filters: Record<string, any> = {}) => {
  return Api.get(API_SERVICING_FORECLOSURE_QUEUE, filters)
}

/** The counts behind the screen header: how many files sit at each stage, parked and closed. */
export const getForeclosureQueueSummary = () => {
  return Api.get(API_SERVICING_FORECLOSURE_QUEUE_SUMMARY)
}

/** The stage ladder itself, so the screen and the pipeline filter name the stages identically. */
export const getForeclosureStages = () => {
  return Api.get(API_SERVICING_FORECLOSURE_STAGES)
}

// --- The extensions work list ---
const API_SERVICING_EXTENSION_QUEUE = '/loan/servicing/extensions/queue'
const API_SERVICING_EXTENSION_QUEUE_SUMMARY = '/loan/servicing/extensions/queue/summary'
const API_SERVICING_EXTENSION_QUEUE_EXCEL = '/loan/servicing/extensions/queue/excel'

/** The month's extensions: the loans maturing in it, and the agreements sent during it. */
export const getExtensionQueue = (filters: Record<string, any>) => {
  return Api.get(API_SERVICING_EXTENSION_QUEUE, filters)
}

/** The counts behind the header: what is due, what has gone out, what the fees are doing. */
export const getExtensionQueueSummary = (filters: Record<string, any>) => {
  return Api.get(API_SERVICING_EXTENSION_QUEUE_SUMMARY, filters)
}

/**
 * The month as a workbook, under the filters the screen has on it.
 *
 * The filters go with the request rather than the rows that are in state, so the sheet is the list
 * as filtered rather than whatever happened to be rendered.
 */
export const downloadExtensionQueueExcel = (filters: Record<string, any>) => {
  return Api.get(API_SERVICING_EXTENSION_QUEUE_EXCEL, filters, {}, { responseType: 'blob', timeout: 120000 })
}

// --- The collections work list ---
const API_SERVICING_COLLECTION_QUEUE = '/loan/servicing/collections/queue'
const API_SERVICING_COLLECTION_QUEUE_BY_ID = '/loan/servicing/collections/queue/:id'
const API_SERVICING_COLLECTION_QUEUE_SUMMARY = '/loan/servicing/collections/queue/summary'
const API_SERVICING_COLLECTION_QUEUE_NEXT = '/loan/servicing/collections/queue/next'
const API_SERVICING_COLLECTION_QUEUE_EXCEL = '/loan/servicing/collections/queue/excel'
const API_SERVICING_COLLECTION_QUEUE_REFRESH = '/loan/servicing/collections/queue/refresh'
const API_SERVICING_COLLECTION_QUEUE_ASSIGN = '/loan/servicing/collections/queue/assign'
const API_LOAN_COLLECTION_QUEUE = '/loan/collectionQueue'
const API_SERVICING_DIALER_CONFIG = '/loan/servicing/collections/dialer/config'

export const getCollectionQueue = (filters: Record<string, any>) => {
  return Api.get(API_SERVICING_COLLECTION_QUEUE, filters)
}

/** The counts behind the queue header: how much is on the list, mine, and unowned. */
export const getCollectionQueueSummary = () => {
  return Api.get(API_SERVICING_COLLECTION_QUEUE_SUMMARY)
}

/** The single loan to work next. */
export const getNextCollectionQueueItem = (scope = 'mine') => {
  return Api.get(API_SERVICING_COLLECTION_QUEUE_NEXT, { scope })
}

/**
 * The list as a workbook, under the filters the screen has on it.
 *
 * The filters go with the request rather than the rows that are in state: the export has to be the
 * list as filtered, and a long list is capped on screen at rows the sheet can still carry.
 */
export const downloadCollectionQueueExcel = (filters: Record<string, any>) => {
  return Api.get(API_SERVICING_COLLECTION_QUEUE_EXCEL, filters, {}, { responseType: 'blob', timeout: 120000 })
}

/** Rebuild the list against today's book instead of waiting for tonight's pass. */
export const refreshCollectionQueue = (data: { asOf?: string } = {}) => {
  return Api.post(API_SERVICING_COLLECTION_QUEUE_REFRESH, data)
}

export const assignCollectionQueue = (data: {
  ids: number[]
  assignedTo?: string
  assignedGroupId?: number | null
}) => {
  return Api.post(API_SERVICING_COLLECTION_QUEUE_ASSIGN, data)
}

export const addToCollectionQueue = (loanNumber: number) => {
  return Api.post(API_SERVICING_COLLECTION_QUEUE, { loanNumber })
}

export const updateCollectionQueueItem = (id: number, data: Record<string, any>) => {
  return Api.put(API_SERVICING_COLLECTION_QUEUE_BY_ID, data, { id })
}

export const deleteCollectionQueueItem = (id: number) => {
  return Api.delete(API_SERVICING_COLLECTION_QUEUE_BY_ID, {}, { id })
}

/** Where the loan in context stands on the list, for its own screens. */
export const getLoanCollectionQueueItem = () => {
  return Api.get(API_LOAN_COLLECTION_QUEUE)
}

export const getCollectionsDialerConfig = () => {
  return Api.get(API_SERVICING_DIALER_CONFIG)
}

export const saveCollectionsDialerConfig = (data: Record<string, any>) => {
  return Api.post(API_SERVICING_DIALER_CONFIG, data)
}

// --- Placing calls ---
const API_LOAN_PHONE_CALL = '/loan/phoneCall'
const API_LOAN_PHONE_CALL_BY_ID = '/loan/phoneCall/:id'
const API_LOAN_PHONE_CALL_STATUS = '/loan/phoneCall/status'
const API_LOAN_PHONE_CALL_CONTACTS = '/loan/phoneCall/contacts'
const API_LOAN_PHONE_CALL_DIAL = '/loan/phoneCall/dial'
const API_LOAN_PHONE_CALL_HANGUP = '/loan/phoneCall/:id/hangup'
const API_LOAN_PHONE_CALL_RECORDING = '/loan/phoneCall/:id/recording'

/** Whether the Call button should work, and what to tell the user when it should not. */
export const getDialerStatus = (): Promise<{ canDial: boolean; reason: string; recording: boolean }> => {
  return Api.get(API_LOAN_PHONE_CALL_STATUS)
}

/** Every number on the loan worth calling. */
export const getCallableContacts = (): Promise<{ name: string; phone: string; role: string; source: string }[]> => {
  return Api.get(API_LOAN_PHONE_CALL_CONTACTS)
}

/**
 * Place a call. Comes back as soon as the carrier accepts it, before anything has rung, so the
 * screen can follow it rather than freeze until somebody picks up.
 */
export const dialPhoneCall = (data: { toNumber: string; contactName?: string; agentPhone?: string }) => {
  return Api.post(API_LOAN_PHONE_CALL_DIAL, data)
}

export const getPhoneCall = (id: number) => {
  return Api.get(API_LOAN_PHONE_CALL_BY_ID, {}, { id })
}

export const getPhoneCalls = (filters: Record<string, any> = {}) => {
  return Api.get(API_LOAN_PHONE_CALL, filters)
}

export const hangupPhoneCall = (id: number) => {
  return Api.post(API_LOAN_PHONE_CALL_HANGUP, {}, { id })
}

/** The recording's audio, as a blob to hand to an <audio> element. */
export const getPhoneCallRecording = (id: number): Promise<Blob> => {
  return Api.get(API_LOAN_PHONE_CALL_RECORDING, {}, { id }, { responseType: 'blob' })
}

// --- Servicing workflow: the thresholds the nightly scan works to ---

export const getServicingWorkflowConfig = () => {
  return Api.get(API_SERVICING_WORKFLOW_CONFIG)
}

export const saveServicingWorkflowConfig = (data: Record<string, any>) => {
  return Api.post(API_SERVICING_WORKFLOW_CONFIG, data)
}

// Runs the scan now instead of waiting for tonight. Same fire-once state, so running it
// twice raises nothing the second time.
export const runServicingWorkflow = (data: { asOf?: string } = {}) => {
  return Api.post(API_SERVICING_WORKFLOW_RUN, data)
}

/** The collections priority list: loans that missed their first or second scheduled payment. */
export const getPaymentDefaults = (params: { includeCured?: boolean; sequence?: number } = {}) => {
  return Api.get(API_SERVICING_PAYMENT_DEFAULTS, {
    includeCured: params.includeCured ? 'true' : 'false',
    sequence: params.sequence || 0,
  })
}

/** Both records for the loan in context, for its own screens. */
export const getLoanPaymentDefaults = () => {
  return Api.get(API_SERVICING_PAYMENT_DEFAULTS_LOAN)
}

/** Re-runs detection now rather than waiting for tonight. Refreshes; never double-raises. */
export const runPaymentDefaultScan = (data: { asOf?: string } = {}) => {
  return Api.post(API_SERVICING_PAYMENT_DEFAULTS_SCAN, data)
}

// --- Payment Import: upload a CSV / Excel file of payments, map its columns to the payment
// fields, preview every row, then post them to the ledger. Not loan-scoped (the file carries the
// loan numbers) unless the import was started from inside one loan. ---
const API_SERVICING_PAYMENT_IMPORT_PARSE = '/loan/servicing/payment-import/parse'
const API_SERVICING_PAYMENT_IMPORT_FIELDS = '/loan/servicing/payment-import/fields'
const API_SERVICING_PAYMENT_IMPORT_SAMPLE = '/loan/servicing/payment-import/sample'
const API_SERVICING_PAYMENT_IMPORT_HISTORY = '/loan/servicing/payment-import/history'
const API_SERVICING_PAYMENT_IMPORT_TEMPLATES = '/loan/servicing/payment-import/templates'
const API_SERVICING_PAYMENT_IMPORT_TEMPLATE = '/loan/servicing/payment-import/templates/:id'
const API_SERVICING_PAYMENT_IMPORT_ONE = '/loan/servicing/payment-import/:id'
const API_SERVICING_PAYMENT_IMPORT_PREVIEW = '/loan/servicing/payment-import/:id/preview'
const API_SERVICING_PAYMENT_IMPORT_COMMIT = '/loan/servicing/payment-import/:id/commit'
const API_SERVICING_PAYMENT_IMPORT_REVERT = '/loan/servicing/payment-import/:id/revert'

export const parsePaymentImportFile = (file: File, options: { loanNumber?: number; hasHeaderRow?: boolean } = {}) => {
  const data: Record<string, any> = { hasHeaderRow: options.hasHeaderRow === false ? 'false' : 'true' }
  if (options.loanNumber) data.loanNumber = String(options.loanNumber)
  return Api.uploadFiles(API_SERVICING_PAYMENT_IMPORT_PARSE, data, {}, [file])
}

export const getPaymentImportFields = () => {
  return Api.get(API_SERVICING_PAYMENT_IMPORT_FIELDS)
}

export const previewPaymentImport = (id: number, mapping: Record<string, number>, options: Record<string, any>) => {
  return Api.post(API_SERVICING_PAYMENT_IMPORT_PREVIEW, { mapping, options }, { id })
}

export const commitPaymentImport = (id: number, mapping: Record<string, number>, options: Record<string, any>) => {
  return Api.post(API_SERVICING_PAYMENT_IMPORT_COMMIT, { mapping, options }, { id })
}

export const revertPaymentImport = (id: number) => {
  return Api.post(API_SERVICING_PAYMENT_IMPORT_REVERT, {}, { id })
}

export const getPaymentImport = (id: number) => {
  return Api.get(API_SERVICING_PAYMENT_IMPORT_ONE, {}, { id })
}

export const getPaymentImportHistory = (loanNumber?: number) => {
  return Api.get(API_SERVICING_PAYMENT_IMPORT_HISTORY, loanNumber ? { loanNumber } : {})
}

export const getPaymentImportTemplates = () => {
  return Api.get(API_SERVICING_PAYMENT_IMPORT_TEMPLATES)
}

export const savePaymentImportTemplate = (data: {
  id?: number
  name: string
  headers: string[]
  mapping: Record<string, number>
  options?: Record<string, any>
}) => {
  return Api.post(API_SERVICING_PAYMENT_IMPORT_TEMPLATES, data)
}

export const deletePaymentImportTemplate = (id: number) => {
  return Api.delete(API_SERVICING_PAYMENT_IMPORT_TEMPLATE, {}, { id })
}

export const downloadPaymentImportSample = async () => {
  const response: Blob = await Api.get(API_SERVICING_PAYMENT_IMPORT_SAMPLE, {}, {}, { responseType: 'blob' })
  downloadFile('Payment Import Template.csv', response)
}

// --- NSF Import: reverse payments the bank returned, from the bank's own returned-items file ---
const API_SERVICING_NSF_IMPORT_PARSE = '/loan/servicing/nsf-import/parse'
const API_SERVICING_NSF_IMPORT_FIELDS = '/loan/servicing/nsf-import/fields'
const API_SERVICING_NSF_IMPORT_SAMPLE = '/loan/servicing/nsf-import/sample'
const API_SERVICING_NSF_IMPORT_HISTORY = '/loan/servicing/nsf-import/history'
const API_SERVICING_NSF_IMPORT_TEMPLATES = '/loan/servicing/nsf-import/templates'
const API_SERVICING_NSF_IMPORT_TEMPLATE = '/loan/servicing/nsf-import/templates/:id'
const API_SERVICING_NSF_IMPORT_ONE = '/loan/servicing/nsf-import/:id'
const API_SERVICING_NSF_IMPORT_PREVIEW = '/loan/servicing/nsf-import/:id/preview'
const API_SERVICING_NSF_IMPORT_COMMIT = '/loan/servicing/nsf-import/:id/commit'
const API_SERVICING_NSF_IMPORT_REVERT = '/loan/servicing/nsf-import/:id/revert'

export const parseNsfImportFile = (file: File, options: { loanNumber?: number; hasHeaderRow?: boolean } = {}) => {
  const data: Record<string, any> = { hasHeaderRow: options.hasHeaderRow === false ? 'false' : 'true' }
  if (options.loanNumber) data.loanNumber = String(options.loanNumber)
  return Api.uploadFiles(API_SERVICING_NSF_IMPORT_PARSE, data, {}, [file])
}

export const getNsfImportFields = () => {
  return Api.get(API_SERVICING_NSF_IMPORT_FIELDS)
}

export const previewNsfImport = (id: number, mapping: Record<string, number>, options: Record<string, any>) => {
  return Api.post(API_SERVICING_NSF_IMPORT_PREVIEW, { mapping, options }, { id })
}

export const commitNsfImport = (id: number, mapping: Record<string, number>, options: Record<string, any>) => {
  return Api.post(API_SERVICING_NSF_IMPORT_COMMIT, { mapping, options }, { id })
}

export const revertNsfImport = (id: number) => {
  return Api.post(API_SERVICING_NSF_IMPORT_REVERT, {}, { id })
}

export const getNsfImport = (id: number) => {
  return Api.get(API_SERVICING_NSF_IMPORT_ONE, {}, { id })
}

export const getNsfImportHistory = (loanNumber?: number) => {
  return Api.get(API_SERVICING_NSF_IMPORT_HISTORY, loanNumber ? { loanNumber } : {})
}

export const getNsfImportTemplates = () => {
  return Api.get(API_SERVICING_NSF_IMPORT_TEMPLATES)
}

export const saveNsfImportTemplate = (data: {
  id?: number
  name: string
  headers: string[]
  mapping: Record<string, number>
  options?: Record<string, any>
}) => {
  return Api.post(API_SERVICING_NSF_IMPORT_TEMPLATES, data)
}

export const deleteNsfImportTemplate = (id: number) => {
  return Api.delete(API_SERVICING_NSF_IMPORT_TEMPLATE, {}, { id })
}

export const downloadNsfImportSample = async () => {
  const response: Blob = await Api.get(API_SERVICING_NSF_IMPORT_SAMPLE, {}, {}, { responseType: 'blob' })
  downloadFile('NSF Import Template.csv', response)
}

// --- Loan Import: board a book of loans into servicing from a spreadsheet ---
const API_SERVICING_LOAN_IMPORT_PARSE = '/loan/servicing/loan-import/parse'
const API_SERVICING_LOAN_IMPORT_FIELDS = '/loan/servicing/loan-import/fields'
const API_SERVICING_LOAN_IMPORT_SAMPLE = '/loan/servicing/loan-import/sample'
const API_SERVICING_LOAN_IMPORT_HISTORY = '/loan/servicing/loan-import/history'
const API_SERVICING_LOAN_IMPORT_TEMPLATES = '/loan/servicing/loan-import/templates'
const API_SERVICING_LOAN_IMPORT_TEMPLATE = '/loan/servicing/loan-import/templates/:id'
const API_SERVICING_LOAN_IMPORT_ONE = '/loan/servicing/loan-import/:id'
const API_SERVICING_LOAN_IMPORT_PREVIEW = '/loan/servicing/loan-import/:id/preview'
const API_SERVICING_LOAN_IMPORT_COMMIT = '/loan/servicing/loan-import/:id/commit'
const API_SERVICING_LOAN_IMPORT_REVERT = '/loan/servicing/loan-import/:id/revert'

export const parseLoanImportFile = (file: File, options: { sheet?: string } = {}) => {
  const data: Record<string, any> = {}
  if (options.sheet) data.sheet = options.sheet
  return Api.uploadFiles(API_SERVICING_LOAN_IMPORT_PARSE, data, {}, [file])
}

export const getLoanImportFields = () => {
  return Api.get(API_SERVICING_LOAN_IMPORT_FIELDS)
}

export const previewLoanImport = (
  id: number,
  mapping: Record<string, number>,
  participantMapping: Record<string, number>,
  options: Record<string, any>,
) => {
  return Api.post(API_SERVICING_LOAN_IMPORT_PREVIEW, { mapping, participantMapping, options }, { id })
}

export const commitLoanImport = (
  id: number,
  mapping: Record<string, number>,
  participantMapping: Record<string, number>,
  options: Record<string, any>,
) => {
  return Api.post(API_SERVICING_LOAN_IMPORT_COMMIT, { mapping, participantMapping, options }, { id })
}

export const revertLoanImport = (id: number) => {
  return Api.post(API_SERVICING_LOAN_IMPORT_REVERT, {}, { id })
}

export const getLoanImport = (id: number) => {
  return Api.get(API_SERVICING_LOAN_IMPORT_ONE, {}, { id })
}

export const getLoanImportHistory = () => {
  return Api.get(API_SERVICING_LOAN_IMPORT_HISTORY)
}

export const getLoanImportTemplates = () => {
  return Api.get(API_SERVICING_LOAN_IMPORT_TEMPLATES)
}

export const saveLoanImportTemplate = (data: {
  id?: number
  name: string
  headers: string[]
  mapping: Record<string, number>
  participantMapping?: Record<string, number>
  options?: Record<string, any>
}) => {
  return Api.post(API_SERVICING_LOAN_IMPORT_TEMPLATES, data)
}

export const deleteLoanImportTemplate = (id: number) => {
  return Api.delete(API_SERVICING_LOAN_IMPORT_TEMPLATE, {}, { id })
}

/** `sheet: 'participants'` downloads the Participants sheet's columns instead of the loan columns. */
export const downloadLoanImportSample = async (sheet?: 'participants') => {
  const response: Blob = await Api.get(
    API_SERVICING_LOAN_IMPORT_SAMPLE,
    sheet ? { sheet } : {},
    {},
    { responseType: 'blob' },
  )
  downloadFile(sheet === 'participants' ? 'Loan Import Participants.csv' : 'Loan Import Template.csv', response)
}

// --- Credit reporting -------------------------------------------------------------------------
// The monthly payment history furnished to the consumer reporting agencies, and the Metro 2 file
// that carries it. Everything except the two per-loan reads is portfolio-wide.

/** Who this tenant is with the bureaus, and what is still missing before a file can be built. */
export const getCreditReportingConfig = () => {
  return Api.get(API_CREDIT_REPORTING_CONFIG)
}

export const saveCreditReportingConfig = (data: Record<string, any>) => {
  return Api.post(API_CREDIT_REPORTING_CONFIG, data)
}

/** The open loan's settings, its stored cycles and what it would report today. */
export const getLoanCreditReporting = () => {
  return Api.get(API_CREDIT_REPORTING_LOAN)
}

export const saveLoanCreditReporting = (data: Record<string, any>) => {
  return Api.post(API_CREDIT_REPORTING_LOAN, data)
}

/** Enrol or drop a set of loans at once, for a servicer working from a list. */
export const setCreditReportingEnrollment = (loanNumbers: number[], enabled: boolean) => {
  return Api.post(API_CREDIT_REPORTING_ENROLL, { loanNumbers, enabled })
}

/** The exact base segment the open loan contributes, as bytes. */
export const previewCreditReportingSegment = (cycle?: string) => {
  return Api.get(API_CREDIT_REPORTING_PREVIEW, cycle ? { cycle } : {})
}

/** Every enrolled loan's position for a cycle — the review before a file is generated. */
export const getCreditReportingCycle = (cycle?: string) => {
  return Api.get(API_CREDIT_REPORTING_CYCLE, cycle ? { cycle } : {})
}

/** Take the month's position now rather than waiting for the scheduled day. */
export const runCreditReportingSnapshot = (data: { cycle?: string; asOfDate?: string } = {}) => {
  return Api.post(API_CREDIT_REPORTING_SNAPSHOT, data)
}

/** Re-check a cycle's exceptions after the underlying loan data has been fixed. */
export const validateCreditReportingCycle = (cycle?: string) => {
  return Api.post(API_CREDIT_REPORTING_VALIDATE, cycle ? { cycle } : {})
}

export const getCreditReportingRuns = () => {
  return Api.get(API_CREDIT_REPORTING_RUNS)
}

export const generateCreditReportingRun = (data: { cycle?: string; asOfDate?: string } = {}) => {
  return Api.post(API_CREDIT_REPORTING_RUNS, data)
}

/** The generated file itself. Plain ASCII, fixed-width — what goes to the bureaus unchanged. */
export const downloadCreditReportingRun = async (id: number, fileName: string) => {
  const response: Blob = await Api.get(API_CREDIT_REPORTING_RUN_DOWNLOAD, {}, { id }, { responseType: 'blob' })
  downloadFile(fileName || `metro2-${id}.txt`, response)
}

/**
 * The readable companion to the file: one line per account as it will be reported, then the loans
 * held back and why. Same run, so it says what the file says rather than what the loans say now.
 */
export const downloadCreditReportingRunReport = async (id: number, cycle: string) => {
  const response: Blob = await Api.get(API_CREDIT_REPORTING_RUN_REPORT, {}, { id }, { responseType: 'blob' })
  downloadFile(`credit-reporting-${cycle}.pdf`, response)
}

/** Mark a file as sent. Nothing transmits from here — the file is handed to the bureaus outside. */
export const submitCreditReportingRun = (id: number) => {
  return Api.post(API_CREDIT_REPORTING_RUN_SUBMIT, {}, { id })
}

/** Abandon a file that was never sent, releasing its cycles so the month can be re-taken. */
export const voidCreditReportingRun = (id: number) => {
  return Api.post(API_CREDIT_REPORTING_RUN_VOID, {}, { id })
}

/** A stored escrow analysis's new monthly escrow, scheduled on Rate & Payment Changes from the payment
 * due on `effectiveDate` (the analysis's computation year start when blank). */
export const applyEscrowAnalysis = (id: number, effectiveDate?: string) => {
  return Api.post(API_LOAN_ESCROW_ANALYSIS_APPLY, { effectiveDate }, { id })
}

/** The loan's Rate & Payment Changes, and how its rate changes are priced. */
export const getTermChanges = () => {
  return Api.get(API_LOAN_TERM_CHANGES)
}

/** Schedule one change, or several at once (a step-rate schedule). */
export const scheduleTermChanges = (
  changes: Array<{ field: string; effectiveDate: string; value: string | number; note?: string; source?: string }>,
) => {
  return Api.post(API_LOAN_TERM_CHANGES, { changes })
}

export const updateTermChange = (
  id: number,
  data: { effectiveDate?: string; value?: string | number; note?: string },
) => {
  return Api.put(API_LOAN_TERM_CHANGE, data, { id })
}

/** Cancel a change that has not taken effect yet. */
export const cancelTermChange = (id: number) => {
  return Api.delete(API_LOAN_TERM_CHANGE, {}, { id })
}

/** "Adjust now": schedule this loan's next ARM adjustment even before its date. */
export const adjustArmNow = () => {
  return Api.post(API_LOAN_ARM_RUN, { force: true })
}

/** ARM Adjustments report: every adjustable-rate loan and whether its next adjustment will go through. */
export const getArmPortfolio = () => {
  return Api.get(API_LOAN_ARM_PORTFOLIO, {}, {}, { timeout: 150000 })
}

/** ARM Adjustments report: recent runs, what each adjusted and skipped. */
export const getArmRuns = () => {
  return Api.get(API_LOAN_ARM_RUNS)
}

/** Run the nightly ARM adjustment for the whole book now. */
export const runArmAdjustments = () => {
  return Api.post(API_LOAN_ARM_RUN_ALL, {}, {}, { timeout: 300000 })
}

/** Produce the borrower's Rate Change Notice for a rate change and file it to the loan's documents. */
export const generateRateChangeNotice = (id: number) => {
  return Api.post(API_LOAN_TERM_CHANGE_NOTICE, {}, { id })
}

/** Email a rate change's latest notice to the borrower. */
export const emailRateChangeNotice = (id: number) => {
  return Api.post(API_LOAN_TERM_CHANGE_NOTICE_EMAIL, {}, { id })
}

/** A rate change's latest notice, as a PDF blob. */
export const downloadRateChangeNotice = (id: number) => {
  return Api.get(API_LOAN_TERM_CHANGE_NOTICE, {}, { id }, { responseType: 'blob' })
}

/** One participant's share of an advance on the global draw screen. */
export interface GlobalDrawAllocation {
  /** `servicing_participation.id`. 0 for the lender's own unsold share. */
  participantId: number
  participantUserId?: string
  participantName: string
  amount: number
}

/**
 * Who the loan is, what each trust ledger bucket holds, and who would fund an advance on it.
 *
 * The loan number is a path parameter, not the `loan-number` header, because the screen moves
 * between loans within one page.
 */
export const getGlobalDrawContext = (loanNumber: number) => {
  return Api.get(API_GLOBAL_DRAW, {}, { loanNumber })
}

/**
 * What a draw screen tells the person entering a draw: the loan's draw inspections with their
 * status, and every reason a servicer would normally refuse the draw. Advice, not a gate - see
 * the backend's `draw-advisory.utils.ts`.
 *
 * The loan number is a path parameter so the pipeline's Draw modal and the loan file's
 * Construction Reserve tab read the same route.
 */
export const getDrawAdvisory = (loanNumber: number, scope: { drawSource?: string; drawId?: number } = {}) => {
  return Api.get(API_DRAW_ADVISORY, scope, { loanNumber })
}

/**
 * The loan's participants and the share of an advance each would fund, including whatever has
 * not been sold down. Used to default the Funded by split on both draw forms.
 */
export const getGlobalDrawParticipants = (loanNumber: number) => {
  return Api.get(API_GLOBAL_DRAW_PARTICIPANTS, {}, { loanNumber })
}

/** Payee suggestions for the loan, so the check is made out to someone already on file. */
export const getGlobalDrawPayees = (loanNumber: number, search = '') => {
  return Api.get(API_GLOBAL_DRAW_PAYEES, { search }, { loanNumber })
}

/** Record one draw against one bucket, split across participants, and queue its check. */
export const addGlobalDraw = (
  loanNumber: number,
  data: {
    bucket: string
    date: string
    reference: string
    amount: number
    fromWhom: string
    /**
     * The eligibility figures the Construction Reserve draw form works out. Stored on the ledger
     * row so a draw taken from the pipeline shows the same columns on the loan's own grid.
     */
    eligibleAmount?: number
    netEligibleAmount?: number
    previouslyDisbursed?: number
    recommendedDisbursement?: number
    inspectionFee?: number
    wireFee?: number
    titleUpdateFee?: number
    additionHoldback?: number
    notes?: string
    trustAccountId?: number
    allocations?: GlobalDrawAllocation[]
    /** The draw inspection this advance was taken against, where one was chosen. Advisory. */
    inspectionOrderId?: number
    inspectionOrderSource?: string
    queueCheck?: boolean
    /** The party or vendor record behind the payee, so the queued check links to it. */
    payeeName?: string
    payeeType?: string
    payeeRefId?: number
    payeeAddress?: string
  },
) => {
  return Api.post(API_GLOBAL_DRAW, data, { loanNumber })
}

// ---------------------------------------------------------------- Debit Requests
//
// Collecting money IN by ACH debit: a borrower's downpayment / cash to close, or an investor's
// funds for a new loan or a construction draw. A request is entered against a loan, reviewed, then
// drafted into an ACH run, from which point the existing ACH screens own the money movement - the
// NACHA debit file and the USIO submission both already live on Servicing > ACH.
//
// Every refusal comes back as `{success: 0, message}` with HTTP 200, so callers read `success`
// rather than catching. Responses never carry an account number in full: only `accountNumberLast4`
// with `hasOwnBanking` and `bankingSource` to say which record the banking came off.

/** This loan's requests, newest first. Reads the `loan-number` header. */
export const getDebitRequests = (status?: string) => {
  return Api.get(API_LOAN_DEBIT_REQUESTS, status ? { status } : {})
}

export const createDebitRequest = (data: Record<string, any>) => {
  return Api.post(API_LOAN_DEBIT_REQUESTS, data)
}

/** Only what is sent is touched, so omitting the banking keeps what is stored. Refused once drafted. */
export const updateDebitRequest = (id: number, data: Record<string, any>) => {
  return Api.put(API_LOAN_DEBIT_REQUEST, data, { id })
}

export const deleteDebitRequest = (id: number) => {
  return Api.delete(API_LOAN_DEBIT_REQUEST, {}, { id })
}

/** Withdraw a request that has not been drafted, keeping it on file. */
export const cancelDebitRequest = (id: number) => {
  return Api.post(API_LOAN_DEBIT_REQUEST_CANCEL, {}, { id })
}

/** The money arrived: mark it settled and book the trust-ledger deposit. */
export const settleDebitRequest = (id: number, settledDate?: string) => {
  return Api.post(API_LOAN_DEBIT_REQUEST_SETTLE, settledDate ? { settledDate } : {}, { id })
}

/**
 * Raise a fresh copy of a returned request. The banking is deliberately not copied - the account
 * that bounced is the thing to re-enter - so the copy needs banking before it can be drafted.
 */
export const reRequestDebitRequest = (id: number) => {
  return Api.post(API_LOAN_DEBIT_REQUEST_RE_REQUEST, {}, { id })
}

/** Every request across loans, for the draft queue. Sends no `loan-number`. */
export const getDebitRequestQueue = (status?: string) => {
  return Api.get(API_LOAN_DEBIT_REQUEST_QUEUE, status ? { status } : {})
}

/** What drafting these would do: who is ready, and why anyone is blocked. */
export const previewDebitRequestDraft = (ids: number[]) => {
  return Api.post(API_LOAN_DEBIT_REQUEST_PREVIEW, { ids })
}

/** Draft the selected requests into one ACH debit run. */
export const draftDebitRequests = (ids: number[], effectiveDate?: string) => {
  return Api.post(API_LOAN_DEBIT_REQUEST_DRAFT, { ids, effectiveDate })
}
